(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lbb-body-kit-i18n"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('lbb-body-kit-i18n-config');
  if (!config || config.dataset.initialized === 'true') return;
  let data;
  try { data = JSON.parse(config.textContent); } catch (_) { return; }
  if (!Array.isArray(data.stages) || data.stages.length !== 8
    || data.stages.some(stage => typeof stage.label !== 'string' || !stage.label)) return;
  // The translation filter escapes HTML; JSON parsing preserves those entities.
  const decodeTranslation = value => {
    if (typeof value !== 'string') return value;
    const entities = { '&amp;': '&', '&quot;': '"', '&apos;': "'", '&#39;': "'", '&#x27;': "'", '&lt;': '<', '&gt;': '>' };
    return value.replace(/&(?:amp|quot|apos|#39|#x27|lt|gt);/g, entity => entities[entity]);
  };
  ['title', 'categoriesLabel', 'optional', 'description'].forEach(key => {
    data[key] = decodeTranslation(data[key]);
  });
  data.stages.forEach(stage => { stage.label = decodeTranslation(stage.label); });
  config.dataset.initialized = 'true';
  let root;
  let observer;
  let pending = false;
  const setText = (node, value) => {
    if (node && value && node.textContent !== value) node.textContent = value;
  };
  const setAttr = (node, key, value) => {
    if (node && value && node.getAttribute(key) !== value) node.setAttribute(key, value);
  };
  const stageOf = (node, fallback) => {
    const value = Number(node.dataset.sectionIndex ?? fallback);
    return Number.isInteger(value) && value >= 0 && value < data.stages.length ? data.stages[value] : null;
  };
  const cleanId = value => {
    const id = String(value ?? '').replace(/^gid:\/\/shopify\/(?:Product|ProductVariant)\//, '');
    return /^\d+$/.test(id) ? id : '';
  };
  const productMap = new Map();
  const handleMap = new Map();
  const variantMap = new Map();
  const titleAliases = new Map();
  const normalizeTitle = value => String(value || '').replace(/\s+/g, ' ').trim();
  Object.entries(data.products || {}).forEach(([id, entry]) => {
    if (!cleanId(id) || !entry || typeof entry.title !== 'string' || !entry.title.trim()) return;
    productMap.set(cleanId(id), entry);
    if (typeof entry.handle === 'string' && entry.handle) handleMap.set(entry.handle, entry);
    Object.entries(entry.variants || {}).forEach(([variantId, title]) => {
      if (cleanId(variantId) && typeof title === 'string') variantMap.set(cleanId(variantId), { product: entry, title });
    });
  });
  const rememberTitle = (value, entry) => {
    const key = normalizeTitle(value);
    if (!key) return;
    if (!titleAliases.has(key)) titleAliases.set(key, entry);
    else if (titleAliases.get(key) !== entry) titleAliases.set(key, null);
  };
  const localizedTitle = (entry, variantId) => {
    const variant = variantMap.get(cleanId(variantId));
    if (!variant || variant.product !== entry || entry.defaultOnly || !variant.title.trim()) return entry.title;
    const compact = value => normalizeTitle(value).toLocaleLowerCase().replace(/\s/g, '');
    return compact(entry.title).includes(compact(variant.title)) ? entry.title : entry.title + ' — ' + variant.title;
  };
  const directProduct = node => {
    const holder = node?.closest('[data-product-id], [data-product-handle]');
    return holder ? productMap.get(cleanId(holder.dataset.productId)) || handleMap.get(holder.dataset.productHandle) : null;
  };
  const translateProducts = () => {
    root.querySelectorAll('.product-card').forEach(card => {
      const entry = productMap.get(cleanId(card.dataset.productId)) || handleMap.get(card.dataset.productHandle);
      if (!entry) return;
      const heading = card.querySelector('.product-title h4');
      rememberTitle(heading?.textContent, entry);
      const controls = Array.from(card.querySelectorAll('.quantity-controls[data-variant-id]'));
      const variantId = controls.length === 1 ? controls[0].dataset.variantId : null;
      const title = localizedTitle(entry, variantId);
      rememberTitle(title, entry);
      setText(heading, title);
      setAttr(card.querySelector('.product-card-image img'), 'alt', title);
    });
    root.querySelectorAll('.scpt-title h4').forEach(heading => {
      const row = heading.closest('.sc-product-item');
      const variantId = row?.dataset.variantId;
      const entry = variantMap.get(cleanId(variantId))?.product || directProduct(heading);
      if (!entry) return;
      const title = localizedTitle(entry, variantId);
      setText(heading, title);
      row?.querySelectorAll('img').forEach(image => setAttr(image, 'alt', title));
    });
    document.querySelectorAll('.product-variant-selector-header-title h3').forEach(heading => {
      const entry = directProduct(heading) || titleAliases.get(normalizeTitle(heading.textContent));
      if (!entry) return;
      const modal = heading.closest('.product-variant-selector');
      if (modal?.dataset.lbbProductDetailsHandle === entry.handle && modal.dataset.lbbProductDetailsTitle) return;
      setText(heading, entry.title);
      heading.closest('.product-variant-selector')?.querySelectorAll('img').forEach(image => setAttr(image, 'alt', entry.title));
    });
  };
  const options = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'data-section-index', 'data-product-id', 'data-product-handle', 'data-variant-id'] };
  const translate = () => {
    pending = false;
    if (!root?.isConnected) return;
    observer.disconnect();
    root.classList.add('lbb-body-kit-i18n');
    setText(root.querySelector('.template-top-data-header-title h2'), data.title);
    const description = root.querySelector('.template-top-data-header-description');
    if (description) {
      const signature = JSON.stringify(data.stages);
      let list = description.querySelector('.lbb-body-kit-categories');
      if (!list || list.dataset.categories !== signature) {
        list = document.createElement('span');
        list.className = 'lbb-body-kit-categories';
        list.dataset.categories = signature;
        list.setAttribute('role', 'list');
        list.setAttribute('aria-label', data.categoriesLabel);
        data.stages.forEach(stage => {
          const pill = document.createElement('span');
          pill.className = 'lbb-body-kit-category';
          pill.setAttribute('role', 'listitem');
          pill.textContent = stage.label;
          list.appendChild(pill);
        });
        description.replaceChildren(list);
      }
    }
    root.querySelectorAll('.condition-link').forEach((button, index) => {
      const stage = stageOf(button, index);
      if (!stage) return;
      setText(button, stage.label);
      setAttr(button, 'title', stage.label);
    });
    root.querySelectorAll('.individual-products-section').forEach((section, index) => {
      const stage = stageOf(section, index);
      if (!stage) return;
      setText(section.querySelector('.section-title'), stage.label);
      setText(section.querySelector('.condition-description'), data.description);
    });
    root.querySelectorAll('.bundle-step-description').forEach(node => setText(node, data.description));
    root.querySelectorAll('.bundle-step-condition').forEach(node => setText(node, data.optional));
    translateProducts();
    observer.observe(document.body, options);
  };
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(translate);
  };
  const start = () => {
    root = document.getElementById('bundlesuiteContainer');
    if (!root) return false;
    observer = new MutationObserver(schedule);
    translate();
    return true;
  };
  if (!start()) {
    const boot = new MutationObserver(() => { if (start()) boot.disconnect(); });
    boot.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => boot.disconnect(), 30000);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-body-kit-ui"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('lbb-body-kit-ui-config');
    if (!config || config.dataset.initialized === 'true') return;
    config.dataset.initialized = 'true';
    const translationEntities = { '&amp;': '&', '&quot;': '"', '&apos;': "'", '&#39;': "'", '&#x27;': "'", '&lt;': '<', '&gt;': '>' };
    const decodeTranslation = value => String(value).replace(/&(?:amp|quot|apos|#39|#x27|lt|gt);/gi, entity => translationEntities[entity.toLowerCase()]);
    const text = Object.fromEntries(Object.entries(config.dataset).map(([key, value]) => [key, key === 'returnUrl' ? value : decodeTranslation(value)]));
    const duoValues = new URLSearchParams(window.location?.search || '').getAll('lbb_duo');
    const duo = duoValues.length === 1 && duoValues[0] === '1';
    if (duo) Object.assign(text, {
      instruction: text.duoInstruction, kitTitle: text.duoKitTitle, addKit: text.duoAddKit,
      review: text.duoReview, empty: text.duoIncomplete, completeSteps: text.duoIncomplete,
      nextStep: text.duoNextCategory
    });
    const stepCount = 8;
    const processed = Array(stepCount).fill(null);
    const mobile = matchMedia('(max-width: 767px)');
    let currentRoot = null;
    let currentCart = null;
    let allowedNative = null;
    let scheduled = false;
    let expanded = false;
    let lastActive = -1;
    let feedback = '';
    let addition = null;
    let additionTimer = 0;
    let navigation = null;
    let navigationTimer = 0;
    let navigationFailed = false;
    let initializing = true;
    let initializationTimer = 0;
    let submitting = false;
    let nativeLoadingSeen = false;
    let requestSeen = false;
    let succeeded = false;
    let confirmedNativeError = false;
    let submissionToken = 0;
    const removals = new Map();
    const duoLimitedButtons = new WeakMap();
    const floatingStyles = new Map();
    let catalogueSource = null;
    let catalogue = { valid: false, products: new Map(), variantOwners: new Map() };
    const rootOf = () => document.getElementById('bundlesuiteContainer');
    const numberOf = element => /^\d+$/.test(element?.dataset.sectionIndex || '') ? Number(element.dataset.sectionIndex) : -1;
    const cleanId = value => { const id = String(value || '').replace(/^gid:\/\/shopify\/(?:Product|ProductVariant)\//, ''); return /^\d+$/.test(id) ? id : ''; };
    const readCatalogue = () => {
      const source = document.getElementById('lbb-body-kit-i18n-config')?.textContent;
      if (source === catalogueSource) return catalogue;
      catalogueSource = source;
      catalogue = { valid: false, products: new Map(), variantOwners: new Map() };
      if (!source) return catalogue;
      try {
        const entries = JSON.parse(source).products;
        if (!entries || typeof entries !== 'object' || Array.isArray(entries)) return catalogue;
        let valid = true;
        Object.entries(entries).forEach(([rawId, product]) => {
          const id = cleanId(rawId);
          if (!id || !product?.variants || typeof product.variants !== 'object' || Array.isArray(product.variants)) { valid = false; return; }
          const variants = new Set(Object.keys(product.variants).map(cleanId));
          if (!variants.size || variants.has('') || catalogue.products.has(id)) { valid = false; return; }
          catalogue.products.set(id, variants);
          variants.forEach(variantId => {
            if (catalogue.variantOwners.has(variantId) && catalogue.variantOwners.get(variantId) !== id) valid = false;
            catalogue.variantOwners.set(variantId, id);
          });
        });
        catalogue.valid = valid && catalogue.products.size > 0;
      } catch (_) { catalogue.valid = false; }
      return catalogue;
    };
    // Native tiers use requirements-not-met as styling; handleCheckout validates the minimum tier.
    const checkoutEnabled = button => button && button.matches('.side-cart-checkout-cta button') && !button.disabled && !button.classList.contains('disabled') && !button.classList.contains('loading') && button.getAttribute('aria-disabled') !== 'true';
    const cardInfo = (card, source = readCatalogue()) => {
      const id = cleanId(card?.dataset.productId);
      const variants = source.products.has(id) ? source.products.get(id) : source.variantOwners.has(id) ? new Set([id]) : new Set();
      const controls = Array.from(card?.querySelectorAll('.quantity-controls[data-variant-id]') || []);
      const valid = source.valid && variants.size > 0 && controls.every(control => !control.dataset.variantId || variants.has(cleanId(control.dataset.variantId)));
      return { id, variants, valid };
    };
    const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
    const setClass = (node, name, value) => { if (node.classList.contains(name) !== value) node.classList.toggle(name, value); };
    const setAttr = (node, name, value) => { if (node.getAttribute(name) !== value) node.setAttribute(name, value); };
    const enabled = button => button && !button.disabled && !button.classList.contains('disabled') && !button.classList.contains('loading') && !button.classList.contains('requirements-not-met') && button.getAttribute('aria-disabled') !== 'true';
    const setNativeLabel = (node, value) => {
      if (!node || !value) return;
      const leaves = Array.from(node.childNodes || []).filter(child => child.nodeType === 3 && child.textContent.trim());
      if (leaves.length === 1) setText(leaves[0], value);
      else if (!node.children?.length) setText(node, value);
    };
    const localizeNativeControls = root => {
      for (const [selector, label] of [['.subtotal-text', text.subtotalLabel || text.subtotal], ['.discount-text', text.discountLabel || text.discount], ['.additional-text', text.discountLabel || text.discount], ['.total-text', text.totalLabel || text.total]]) {
        root.querySelectorAll('.side-cart-checkout-wrapper ' + selector).forEach(node => setNativeLabel(node, label));
      }
      root.querySelectorAll('.cart-empty').forEach(node => setNativeLabel(node, text.emptyKit));
      root.querySelectorAll('.cart-totoal-added-products p').forEach(node => {
        const counter = node.querySelector('.added-products-count');
        const raw = counter ? counter.textContent.trim() : node.textContent.trim().match(/^(\d+)\s+/)?.[1];
        if (!/^\d+$/.test(raw || '') || !Number.isSafeInteger(Number(raw))) return;
        const label = Number(raw) === 1 ? text.nativeItemOne : text.nativeItemMany;
        setNativeLabel(node, counter ? ' ' + label : raw + ' ' + label);
      });
      document.querySelectorAll('.product-variant-selector-cta button').forEach(button => {
        if (button.classList.contains('loading') || button.dataset.preOrder === 'true') return;
        const label = button.dataset.stockStatus === 'out-of-stock' || /^(?:out of stock|sold out|unavailable|indisponible|rupture de stock|épuisé)$/i.test(button.textContent.trim())
          ? text.unavailable : button.dataset.stockStatus === 'in-stock' || /^(?:add to (?:cart|bundle)|ajouter au (?:panier|kit)|choisir)$/i.test(button.textContent.trim()) ? text.addProduct : null;
        if (label) { setNativeLabel(button, label); setAttr(button, 'aria-label', label); }
      });
      const scopes = [root, ...document.querySelectorAll('.product-variant-selector')];
      scopes.forEach(scope => {
        scope.querySelectorAll('.close-variant-selector button').forEach(button => { setAttr(button, 'aria-label', text.close); setAttr(button, 'title', text.close); });
        for (const [selector, label] of [['.quantity-input', text.quantity], ['.quantity-btn.plus', text.increase], ['.quantity-btn.minus', text.decrease], ['.remove-item-btn', text.remove]]) {
          scope.querySelectorAll(selector).forEach(node => {
            const holder = node.closest('.sc-product-item, .product-card, .product-variant-selector');
            const title = holder?.querySelector('.scpt-title h4, .product-title h4, .product-variant-selector-header-title h3')?.textContent.replace(/\s+/g, ' ').trim();
            setAttr(node, 'aria-label', label + (title ? ' : ' + title : ''));
          });
        }
        scope.querySelectorAll('[aria-label]').forEach(node => {
          const label = node.getAttribute('aria-label');
          if (/^(?:regular price|prix normal|prix habituel)$/i.test(label)) setAttr(node, 'aria-label', text.regularPrice);
          else if (/^(?:sale price|prix réduit|prix promotionnel)$/i.test(label)) setAttr(node, 'aria-label', text.salePrice);
          else if (/^view product$/i.test(label)) setAttr(node, 'aria-label', text.viewProduct);
        });
      });
      document.body.querySelectorAll('[aria-label]').forEach(node => {
        const label = node.getAttribute('aria-label');
        if (/^previous slide$/i.test(label)) setAttr(node, 'aria-label', text.previousSlide);
        else if (/^next slide$/i.test(label)) setAttr(node, 'aria-label', text.nextSlide);
      });
      document.querySelectorAll('.bundle-toast.success .bundle-toast-message').forEach(node => {
        const message = node.textContent.trim();
        if (message === text.addedToCart) return;
        if (/^(?:(?:product|item) )?added to cart[.!]?$/i.test(message)) setNativeLabel(node, text.addedToCart);
        else if (/^Added .+ to bundle[.!]?$/i.test(message) || /^.+ ajout[ée]e? (?:au|dans le) (?:kit|panier|bundle)[.!]?$/i.test(message)) setNativeLabel(node, text.productAdded);
        else if (/^Removed .+ from bundle[.!]?$/i.test(message) || /^.+ retir[ée]e? (?:du|de votre) (?:kit|panier|bundle)[.!]?$/i.test(message)) setNativeLabel(node, text.productRemoved);
      });
    };
    const snapshot = root => {
      const source = readCatalogue();
      const sections = Array.from(root.querySelectorAll('.individual-products-section[data-section-index]')).sort((a, b) => numberOf(a) - numberOf(b));
      const tabs = Array.from(root.querySelectorAll('.condition-link[data-section-index]')).sort((a, b) => numberOf(a) - numberOf(b));
      const rows = Array.from(root.querySelectorAll('.sc-product-item[data-variant-id]'));
      const selected = new Map();
      const membership = new Map();
      const choices = Array(stepCount).fill(null);
      let valid = source.valid && sections.length === stepCount && tabs.length === stepCount;
      sections.forEach((section, index) => {
        if (numberOf(section) !== index || numberOf(tabs[index]) !== index) valid = false;
        section.querySelectorAll('.product-card[data-product-id]').forEach(card => {
          const info = cardInfo(card, source);
          if (!info.valid) valid = false;
          info.variants.forEach(id => {
            if (membership.has(id) && membership.get(id) !== index) valid = false;
            membership.set(id, index);
          });
        });
      });
      rows.forEach(row => {
        const id = cleanId(row.dataset.variantId);
        const index = membership.get(id);
        if (!id || selected.has(id) || index === undefined || index >= stepCount || choices[index] || row.querySelector('.scpt-price-quantity')?.textContent.trim() !== '1') valid = false;
        else choices[index] = id;
        selected.set(id, row);
      });
      const activeTabs = tabs.filter(tab => tab.classList.contains('active'));
      const index = activeTabs.length === 1 ? numberOf(activeTabs[0]) : -1;
      if (index < 0 || index >= stepCount) valid = false;
      return { root, sections, tabs, rows, selected, membership, choices, index, valid };
    };
    const reconcile = state => {
      processed.forEach((value, index) => {
        if (value === 'skip' && state.choices[index]) processed[index] = null;
        else if (value && value !== 'skip' && value !== state.choices[index]) processed[index] = null;
      });
    };
    const firstPending = () => { if (window.LBBLissageKitEdit?.active || duo) return stepCount - 1; const index = processed.indexOf(null); return index < 0 ? stepCount - 1 : index; };
    const finished = state => state.valid && (window.LBBLissageKitEdit?.active ? state.rows.length > 0 : duo ? state.rows.length === 2 : processed.every((value, index) => value && (value === 'skip' ? !state.choices[index] : value === state.choices[index])));
    const limitDuoButton = (button, limited) => {
      if (limited) {
        if (!duoLimitedButtons.has(button)) duoLimitedButtons.set(button, button.getAttribute('aria-disabled'));
        setAttr(button, 'data-lbb-body-duo-limit', 'true');
        setAttr(button, 'aria-disabled', 'true');
      } else if (duoLimitedButtons.has(button)) {
        const previous = duoLimitedButtons.get(button);
        if (previous === null) button.removeAttribute('aria-disabled');
        else setAttr(button, 'aria-disabled', previous);
        button.removeAttribute('data-lbb-body-duo-limit');
        duoLimitedButtons.delete(button);
      }
    };
    const clearAddition = () => { addition = null; clearTimeout(additionTimer); additionTimer = 0; };
    const stop = event => { event.preventDefault(); event.stopImmediatePropagation(); };
    const nativeClick = element => {
      allowedNative = element;
      try { element.click(); } finally { allowedNative = null; }
    };
    const clearNavigation = () => { navigation = null; clearTimeout(navigationTimer); navigationTimer = 0; };
    const focusStep = section => {
      const target = section?.querySelector('.section-title, h2, h3') || section;
      if (!target || !target.getClientRects().length) return;
      setAttr(target, 'tabindex', '-1');
      target.focus({ preventScroll: true });
      section.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    const goTo = (state, index, focus = true) => {
      if (!state.valid || !Number.isInteger(index) || index < 0 || index >= stepCount || index > firstPending()) return false;
      if (index === state.index) { clearNavigation(); navigationFailed = false; if (focus) focusStep(state.sections[index]); return true; }
      const direction = index > state.index ? 1 : -1;
      const nextIndex = state.index + direction;
      if (nextIndex < 0 || nextIndex >= stepCount || (direction > 0 && nextIndex > firstPending())) return false;
      const button = Array.from(state.root.querySelectorAll(direction > 0 ? '.bundle-step-button.next-step' : '.bundle-step-button.prev-step')).find(enabled);
      if (!button) return false;
      clearNavigation();
      navigationFailed = false;
      const operation = { root: state.root, index, focus, from: state.index, expected: nextIndex };
      navigation = operation;
      expanded = false;
      nativeClick(button);
      navigationTimer = setTimeout(() => {
        if (navigation === operation) { clearNavigation(); navigationFailed = true; feedback = text.configurationError; schedule(); }
      }, 2000);
      schedule();
      return true;
    };
    const finishStep = state => {
      if (!state.valid || state.index > firstPending()) return false;
      processed[state.index] = state.choices[state.index] || 'skip';
      feedback = '';
      if (state.index < stepCount - 1) return goTo(state, state.index + 1);
      expanded = true;
      schedule();
      return true;
    };
    const removalFor = (state, id) => {
      const matches = state.rows.filter(row => row.dataset.variantId === id);
      if (matches.length !== 1) return null;
      const button = matches[0].querySelector('.remove-item-btn');
      return enabled(button) ? button : null;
    };
    const make = (tag, className, content) => {
      const node = document.createElement(tag);
      node.className = className;
      if (content) node.textContent = content;
      if (tag === 'button') node.type = 'button';
      return node;
    };
    const controlsFor = cart => {
      let controls = cart.querySelector('.lbb-body-kit-controls');
      if (controls) return controls;
      controls = make('div', 'lbb-body-kit-controls');
      controls.append(make('p', 'lbb-body-kit-offer', text.offer));
      controls.append(make('span', 'lbb-body-kit-progress'));
      const status = make('p', 'lbb-body-kit-status');
      status.id = 'lbb-body-kit-status';
      setAttr(status, 'role', 'status');
      setAttr(status, 'aria-live', 'polite');
      controls.append(status);
      const actions = make('div', 'lbb-body-kit-actions');
      for (const action of ['previous', 'next', 'submit']) {
        const button = make('button', 'lbb-body-kit-' + action);
        button.dataset.bodyKitAction = action;
        setAttr(button, 'aria-describedby', status.id);
        actions.append(button);
      }
      controls.append(actions);
      cart.append(controls);
      return controls;
    };
    const gridControlsFor = section => {
      const grid = section.querySelector('.individual-products-container');
      if (!grid) return [];
      return ['top', 'bottom'].map(position => {
        let controls = section.querySelector('.lbb-body-kit-grid-nav--' + position);
        if (!controls) {
          controls = make('div', 'lbb-body-kit-actions lbb-body-kit-grid-nav lbb-body-kit-grid-nav--' + position);
          setAttr(controls, 'role', 'group');
          for (const action of ['previous', 'next']) {
            const button = make('button', 'lbb-body-kit-' + action);
            button.dataset.bodyKitAction = action;
            button.dataset.bodyKitSectionIndex = String(numberOf(section));
            setAttr(button, 'aria-describedby', 'lbb-body-kit-status');
            controls.append(button);
          }
          if (position === 'top') grid.before(controls);
          else grid.after(controls);
        }
        return controls;
      });
    };
    const toggleFor = cart => {
      let toggle = cart.querySelector('.lbb-body-kit-toggle');
      if (toggle) return toggle;
      toggle = make('button', 'lbb-body-kit-toggle');
      toggle.dataset.bodyKitAction = 'toggle';
      const label = make('span', 'lbb-body-kit-toggle-label');
      label.append(make('strong', '', text.kitTitle), make('span', 'lbb-body-kit-toggle-action'));
      toggle.append(label, make('span', 'lbb-body-kit-toggle-total'));
      cart.prepend(toggle);
      return toggle;
    };
    const updateSpace = () => {
      const active = mobile.matches && !!currentRoot && !!currentCart;
      setClass(document.documentElement, 'lbb-body-kit-mobile', active);
      const height = active ? Math.ceil(currentCart.getBoundingClientRect().height) : 0;
      if (active && height > 0 && !expanded && currentRoot.style.getPropertyValue('--lbb-body-kit-space') !== height + 'px') currentRoot.style.setProperty('--lbb-body-kit-space', height + 'px');
      const bottom = Math.max(height, 140) + 12;
      const rules = [
        ['shopify-chat', '.activator-nudge{bottom:' + bottom + 'px!important;width:44px!important;max-width:44px!important;min-width:44px!important;height:44px!important;padding:0!important}.activator-nudge>button.activator[part="activator"]{width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;padding:0!important;gap:0!important}.activator__label{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important}'],
        ['pandectes-cmp', 'button.widget.bottom.left{bottom:' + bottom + 'px!important}']
      ];
      rules.forEach(([selector, css]) => {
        const shadow = document.querySelector(selector)?.shadowRoot;
        let style = floatingStyles.get(selector);
        if (style && (!active || style.parentNode !== shadow)) { style.remove(); floatingStyles.delete(selector); style = null; }
        if (!active || !shadow) return;
        if (!style) { style = document.createElement('style'); shadow.append(style); floatingStyles.set(selector, style); }
        setText(style, '@media(max-width:767px){' + css + '}');
      });
    };
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(updateSpace) : null;
    const resetSubmission = message => {
      submitting = false;
      nativeLoadingSeen = false;
      requestSeen = false;
      succeeded = false;
      confirmedNativeError = false;
      submissionToken++;
      if (message) feedback = message;
      schedule();
    };
    const render = () => {
      const root = rootOf();
      const cart = root?.querySelector('.side-cart-container');
      if (!root || !cart) { currentRoot = null; currentCart = null; updateSpace(); return; }
      if (currentRoot !== root) {
        processed.fill(null);
        clearAddition();
        removals.clear();
        lastActive = -1;
        expanded = false;
        feedback = '';
        clearNavigation();
        navigationFailed = false;
        resetSubmission();
        currentRoot = root;
      }
      if (currentCart !== cart) { resize?.disconnect(); currentCart = cart; resize?.observe(cart); }
      setClass(root, 'lbb-body-kit', true);
      setClass(root, 'lbb-body-kit-duo', duo);
      let back = document.getElementById('lbb-body-kit-back');
      if (!back) { back = make('a', 'lbb-body-kit-back', text.back); back.id = 'lbb-body-kit-back'; back.href = text.returnUrl; root.before(back); }
      const tabs = root.querySelector('.condition-links-container');
      if (duo) {
        let title = root.querySelector('.lbb-body-kit-duo-title');
        if (!title) { title = make('h2', 'lbb-body-kit-duo-title', text.duoTitle); if (tabs) tabs.before(title); }
        const titleHost = root.querySelector('.template-top-data-header-title');
        if (titleHost && title.parentElement !== titleHost) titleHost.append(title);
      }
      if (tabs && !root.querySelector('.lbb-body-kit-instruction')) tabs.before(make('p', 'lbb-body-kit-instruction', text.instruction));
      const state = snapshot(root);
      if (state.valid) { initializing = false; clearTimeout(initializationTimer); initializationTimer = 0; }
      else if (initializing && !initializationTimer) initializationTimer = setTimeout(() => { initializing = false; schedule(); }, 5000);
      reconcile(state);
      const nativeCheckout = root.querySelector('.side-cart-checkout-cta button');
      if (confirmedNativeError && nativeCheckout && !nativeCheckout.disabled && !nativeCheckout.classList.contains('disabled')) {
        nativeCheckout.classList.remove('loading');
        resetSubmission(text.submitError);
      }
      const loading = !!nativeCheckout?.classList.contains('loading');
      if (submitting && loading) nativeLoadingSeen = true;
      if (submitting && nativeLoadingSeen && !loading && !succeeded && !requestSeen) resetSubmission(text.submitError);
      if (state.index !== lastActive) { expanded = false; lastActive = state.index; }
      if (addition && (addition.root !== root || addition.index !== state.index)) clearAddition();
      if (addition && state.valid) {
        const accepted = state.choices[addition.index];
        if (accepted && addition.variants.has(accepted) && !addition.before.has(accepted)) {
          const index = addition.index;
          clearAddition();
          processed[index] = accepted;
          feedback = '';
          if (duo && state.rows.length >= 2) expanded = true;
          else if (index < stepCount - 1) goTo(state, index + 1);
          else expanded = true;
        }
      }
      const activeState = snapshot(root);
      reconcile(activeState);
      if (activeState.valid && activeState.index <= firstPending()) navigationFailed = false;
      if (activeState.valid && activeState.index > firstPending() && !submitting && !navigation && !navigationFailed) goTo(activeState, firstPending(), false);
      if (navigation && navigation.root === root && activeState.valid) {
        const operation = navigation;
        if (activeState.index === operation.index) {
          clearNavigation();
          if (operation.focus) focusStep(activeState.sections[operation.index]);
        } else if (activeState.index === operation.expected) {
          clearNavigation();
          if (!goTo(activeState, operation.index, operation.focus)) feedback = text.configurationError;
        } else if (activeState.index !== operation.from) {
          clearNavigation();
          navigationFailed = true;
          feedback = text.configurationError;
        }
      }
      const done = finished(activeState);
      const cartEdit = window.LBBLissageKitEdit;
      const editBlocked = cartEdit?.active && (!cartEdit.ready || cartEdit.blocked || cartEdit.saving);
      const saveLabel = cartEdit?.active ? cartEdit.saveLabel : text.addKit;
      const busy = submitting || !!addition || !!navigation || removals.size > 0 || !!editBlocked;
      const controls = controlsFor(cart);
      activeState.sections.forEach(section => {
        const index = numberOf(section);
        gridControlsFor(section).forEach(group => {
          const active = index === activeState.index;
          const unavailable = !activeState.valid || !active || busy;
          setAttr(group, 'aria-label', (duo ? text.duoCategoryProgress : text.progress).replace('[current]', String(index + 1)).replace('[total]', String(stepCount)));
          const previous = group.querySelector('.lbb-body-kit-previous');
          const next = group.querySelector('.lbb-body-kit-next');
          setText(previous, text.previous);
          previous.disabled = unavailable || index === 0;
          setText(next, cartEdit?.active && index === stepCount - 1 ? saveLabel : text.nextStep);
          next.disabled = unavailable || (!cartEdit?.active && index === stepCount - 1 && (duo || done));
        });
      });
      const previous = controls.querySelector('.lbb-body-kit-previous');
      const next = controls.querySelector('.lbb-body-kit-next');
      const submit = controls.querySelector('.lbb-body-kit-submit');
      setText(previous, text.previous);
      previous.disabled = !activeState.valid || activeState.index === 0 || busy;
      setText(next, duo ? text.duoNextCategory : activeState.choices[activeState.index] ? text.continue : text.skip);
      next.hidden = done || (duo && activeState.index === stepCount - 1);
      next.disabled = !activeState.valid || busy;
      setText(submit, submitting ? text.adding : saveLabel);
      submit.hidden = !cartEdit?.active && !duo && !done;
      submit.disabled = !done || !activeState.rows.length || busy || !checkoutEnabled(nativeCheckout);
      setText(controls.querySelector('.lbb-body-kit-progress'), duo ? text.duoProgress.replace('[count]', String(activeState.rows.length)) : text.progress.replace('[current]', String(Math.max(0, activeState.index) + 1)).replace('[total]', String(stepCount)));
      setText(controls.querySelector('.lbb-body-kit-status'), feedback || (!activeState.valid ? initializing ? text.loading : text.configurationError : duo && activeState.rows.length > 2 ? text.duoExcess : done ? activeState.rows.length ? text.review : text.empty : duo ? text.duoIncomplete : ''));
      root.setAttribute('aria-busy', submitting || (!activeState.valid && initializing) ? 'true' : 'false');
      activeState.tabs.forEach(tab => setAttr(tab, 'aria-disabled', numberOf(tab) > firstPending() || submitting ? 'true' : 'false'));
      setText(root.querySelector('.cart-head h3'), text.kitTitle);
      localizeNativeControls(root);
      const toggle = toggleFor(cart);
      setAttr(toggle, 'aria-expanded', mobile.matches && expanded ? 'true' : 'false');
      const controlled = [];
      for (const [selector, suffix] of [['.side-cart-header', 'header'], ['.side-cart-product-container', 'products'], ['.side-cart-checkout-wrapper', 'totals']]) {
        const panel = cart.querySelector(selector);
        if (!panel) continue;
        if (!panel.id) panel.id = 'lbb-body-kit-panel-' + suffix;
        controlled.push(panel.id);
      }
      setAttr(toggle, 'aria-controls', controlled.join(' '));
      setText(toggle.querySelector('.lbb-body-kit-toggle-action'), expanded ? text.collapse : text.details);
      const total = root.querySelector('.side-cart-checkout-wrapper .total-value')?.textContent.trim() || '';
      setText(toggle.querySelector('.lbb-body-kit-toggle-total'), activeState.rows.length && total ? text.total + ' ' + total : '');
      setClass(cart, 'lbb-body-kit-open', mobile.matches && expanded);
      removals.forEach((operation, id) => { if (!activeState.selected.has(id)) { clearTimeout(operation.timer); removals.delete(id); schedule(); } });
      root.querySelectorAll('.product-card[data-product-id]').forEach(card => {
        const info = cardInfo(card);
        const variants = info.valid ? info.variants : new Set();
        const selected = [...variants].filter(id => activeState.selected.has(id));
        setClass(card, 'lbb-body-kit-selected', selected.length > 0);
        const selectedId = selected.length === 1 ? selected[0] : null;
        let remove = card.querySelector('.lbb-body-kit-remove');
        const cta = card.querySelector('.product-card-cta');
        const canRemove = selectedId && cta && removalFor(activeState, selectedId);
        if (canRemove) {
          if (!remove) { remove = make('button', 'lbb-body-kit-remove'); remove.dataset.bodyKitAction = 'remove'; }
          if (remove.parentElement !== cta) cta.append(remove);
          remove.dataset.variantId = selectedId;
          remove.disabled = submitting || !!navigation || removals.has(selectedId);
          setText(remove, text.removeChoice);
          const title = card.querySelector('.product-title h4')?.textContent.trim();
          setAttr(remove, 'aria-label', text.removeChoice + (title ? ' : ' + title : ''));
        } else remove?.remove();
        card.querySelectorAll('.add-button').forEach(button => {
          limitDuoButton(button, duo && activeState.rows.length >= 2 && !canRemove);
          if (canRemove) {
            button.setAttribute('data-lbb-body-replaced', 'true');
          } else {
            button.removeAttribute('data-lbb-body-replaced');
            if (button.dataset.stockStatus === 'out-of-stock') setText(button, text.unavailable);
            else if (button.hasAttribute('data-lbb-body-duo-limit')) setText(button, text.duoLimit);
            else if (enabled(button)) setText(button, text.choose);
            else if (button.classList.contains('disabled')) setText(button, text.otherChoice);
            if (!button.classList.contains('loading') && button.dataset.preOrder !== 'true') setAttr(button, 'aria-label', button.textContent.trim());
          }
        });
      });
      updateSpace();
    };
    const observer = new MutationObserver(() => schedule());
    const observe = () => observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'disabled', 'data-variant-id', 'data-section-index', 'data-stock-status'] });
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        observer.disconnect();
        try { render(); } finally { observe(); }
      });
    }
    const submitKit = state => {
      const cartEdit = window.LBBLissageKitEdit;
      if (cartEdit?.active) { if (state.valid && !addition && !navigation && !removals.size) cartEdit.save(); return; }
      reconcile(state);
      if (submitting || addition || navigation || removals.size) return;
      if (!finished(state)) { feedback = text.completeSteps; schedule(); return; }
      if (!state.rows.length) { feedback = text.empty; schedule(); return; }
      const actions = Array.from(state.root.querySelectorAll('.side-cart-checkout-cta button')).filter(checkoutEnabled);
      if (actions.length !== 1) { feedback = text.configurationError; schedule(); return; }
      const token = ++submissionToken;
      submitting = true;
      requestSeen = false;
      succeeded = false;
      confirmedNativeError = false;
      feedback = '';
      nativeLoadingSeen = false;
      nativeClick(actions[0]);
      nativeLoadingSeen = actions[0].classList.contains('loading');
      schedule();
      setTimeout(() => {
        if (token === submissionToken && !nativeLoadingSeen && !requestSeen && !succeeded) resetSubmission(text.submitError);
      }, 1500);
    };
    document.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const root = rootOf();
      const popupChoice = target?.closest('.product-variant-selector-cta button');
      if (!root || !target || (!root.contains(target) && !popupChoice)) return;
      if (allowedNative && (target === allowedNative || allowedNative.contains(target))) return;
      const cartEdit = window.LBBLissageKitEdit;
      if (cartEdit?.active && (!cartEdit.ready || cartEdit.blocked || cartEdit.saving)) { stop(event); return; }
      const state = snapshot(root);
      reconcile(state);
      const custom = target.closest('[data-body-kit-action]');
      if (custom) {
        stop(event);
        const action = custom.dataset.bodyKitAction;
        if (action === 'toggle') { expanded = !expanded; schedule(); return; }
        if (custom.disabled || submitting || navigation) return;
        if (custom.dataset.bodyKitSectionIndex !== undefined && Number(custom.dataset.bodyKitSectionIndex) !== state.index) return;
        if (action === 'submit') { submitKit(state); return; }
        if (action === 'previous') { clearAddition(); feedback = ''; goTo(state, Math.min(state.index - 1, firstPending())); return; }
        if (action === 'next') {
          if (cartEdit?.active && state.index === stepCount - 1) { submitKit(state); return; }
          if (addition || removals.size) return;
          const completed = finishStep(state);
          if (completed && state.index === stepCount - 1 && custom.dataset.bodyKitSectionIndex !== undefined) {
            requestAnimationFrame(() => {
              const summary = currentCart?.querySelector('.lbb-body-kit-controls');
              if (summary) { setAttr(summary, 'tabindex', '-1'); summary.focus({ preventScroll: true }); summary.scrollIntoView({ block: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
            });
          }
          return;
        }
        if (action === 'remove') {
          clearAddition();
          const id = custom.dataset.variantId;
          const card = custom.closest('.product-card[data-product-id]');
          const info = cardInfo(card);
          const belongs = info.valid && info.variants.has(id);
          const button = belongs && removalFor(state, id);
          if (!button || removals.has(id)) return;
          const operation = { timer: 0 };
          removals.set(id, operation);
          custom.disabled = true;
          nativeClick(button);
          operation.timer = setTimeout(() => { if (removals.get(id) === operation) { removals.delete(id); schedule(); } }, 2000);
          schedule();
        }
        return;
      }
      const nativeFinal = target.closest('.side-cart-checkout-cta button');
      const next = target.closest('.bundle-step-button.next-step');
      const previous = target.closest('.bundle-step-button.prev-step');
      const tab = target.closest('.condition-link[data-section-index]');
      if (nativeFinal || next || previous || tab) {
        stop(event);
        if (submitting || navigation) return;
        if (nativeFinal) { submitKit(state); return; }
        if (next) { if (!addition && !removals.size) finishStep(state); return; }
        clearAddition();
        const index = previous ? Math.min(state.index - 1, firstPending()) : numberOf(tab);
        if (!goTo(state, index)) { feedback = text.completeSteps; schedule(); }
        return;
      }
      const remove = target.closest('.remove-item-btn');
      if (remove) { if (submitting || navigation) stop(event); clearAddition(); schedule(); return; }
      const add = popupChoice || target.closest('.add-button');
      if (!add) return;
      if (duo && state.rows.length >= 2) { stop(event); feedback = state.rows.length > 2 ? text.duoExcess : text.duoReview; schedule(); return; }
      if (submitting || navigation || (addition && !popupChoice) || removals.size || !state.valid || !enabled(add)) { stop(event); return; }
      const activeCards = popupChoice ? Array.from(root.querySelectorAll('.product-card[data-product-id][data-active="true"]')) : [];
      const card = popupChoice ? activeCards.length === 1 ? activeCards[0] : null : add.closest('.product-card[data-product-id]');
      const section = card?.closest('.individual-products-section[data-section-index]');
      const index = numberOf(section);
      const info = cardInfo(card);
      const exactVariant = cleanId(add.closest('.quantity-controls[data-variant-id]')?.dataset.variantId);
      const variants = exactVariant ? new Set([exactVariant]) : info.variants;
      if (!card || !info.valid || index !== state.index || index > firstPending() || state.choices[index] || !variants.size || [...variants].some(id => !info.variants.has(id) || state.selected.has(id))) { stop(event); return; }
      feedback = '';
      clearAddition();
      addition = { root, index, variants, before: new Set(state.selected.keys()) };
      additionTimer = setTimeout(() => { clearAddition(); schedule(); }, 8000);
      schedule();
    }, true);
    document.addEventListener('change', event => {
      if (!addition) return;
      const target = event.target instanceof Element ? event.target : null;
      const card = target?.closest('.product-card[data-product-id]');
      if (card && ![...cardInfo(card).variants].some(id => addition.variants.has(id))) clearAddition();
    }, true);
    const onCartRequest = event => {
      const state = event.detail?.state;
      if (state === 'pending') { submitting = true; requestSeen = true; clearAddition(); }
      else if (state === 'success') { submitting = true; requestSeen = true; succeeded = true; }
      else if (state === 'error') { confirmedNativeError = true; feedback = text.submitError; }
      schedule();
    };
    document.addEventListener('lbb:body-kit-cart-request', onCartRequest);
    document.addEventListener('lbb:lissage-kit-cart-request', onCartRequest);
    window.addEventListener('pageshow', event => { if (event.persisted) { clearAddition(); resetSubmission(); } });
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && expanded) { expanded = false; schedule(); currentCart?.querySelector('.lbb-body-kit-toggle')?.focus(); } });
    mobile.addEventListener('change', () => { expanded = false; schedule(); });
    observe();
    schedule();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-cart-kit-summary"] && !Shopify.designMode) return;
  try {
    (() => {
  if(customElements.get('lbb-cart-kit-summary'))return;
  const policies={
    '15689118744841':{minimum:2,lissages:['57175771054345','57175796973833','57175820697865']},
    '15689165406473':{minimum:2,lissages:['44451037544713','44450767503625','44451046883593']},
    '15686744375561':{minimum:1,lissages:[]},
    '15686016532745':{minimum:2,lissages:[]},
    '15705118310665':{minimum:2,lissages:["57445681496329","57445773508873"],single:false},
    '15705139052809':{minimum:2,lissages:["48749677871369","57445773476105"],single:false}
  };
  const integer=value=>typeof value==='string'&&/^\d+$/.test(value)&&Number.isSafeInteger(Number(value))?Number(value):null;
  function lineSavings(line){
    const parent=line.dataset.parentId,policy=policies[parent];
    const singleMode=line.dataset.lissageMode==='single';
    if(singleMode&&(!policy?.lissages.length||policy.single===false))throw Error('single-parent');
    const minimum=singleMode?1:policy?.minimum;
    const quantity=integer(line.dataset.parentQuantity),total=integer(line.dataset.finalTotal);
    const bundle=JSON.parse(line.dataset.composition);
    if(!policy||quantity===null||quantity<1||total===null||bundle?.v!==2||String(bundle.s?._BS_productId)!==parent||!Array.isArray(bundle.c)||!bundle.c.length)throw Error('kit');
    const choices=new Map();let units=0,lissageUnits=0;
    for(const tuple of bundle.c){
      const id=String(tuple?.[0]),count=tuple?.[1];
      if(!Array.isArray(tuple)||tuple.length!==3||!/^[1-9]\d*$/.test(id)||choices.has(id)||!Number.isSafeInteger(count)||count<1||!Number.isSafeInteger(tuple[2])||tuple[2]<0)throw Error('choice');
      choices.set(id,count);units+=count;if(policy.lissages.includes(id))lissageUnits+=count;
    }
    if(!Number.isSafeInteger(units)||units<minimum||(policy.lissages.length&&lissageUnits<1)||(singleMode&&lissageUnits!==units))throw Error('minimum');
    const prices=new Map(),physical=new Map();
    for(const row of line.querySelectorAll('[data-component-id]')){
      const id=row.dataset.componentId,price=integer(row.dataset.referencePrice),count=integer(row.dataset.physicalQuantity);
      if(!choices.has(id)||price===null||count===null||count<1||Number(row.dataset.nestedComponents)>0)throw Error('metadata');
      if(prices.has(id)&&prices.get(id)!==price)throw Error('price');
      prices.set(id,price);
      const aggregate=(physical.get(id)||0)+count;
      if(!Number.isSafeInteger(aggregate))throw Error('quantity');
      physical.set(id,aggregate);
    }
    const matches=multiplier=>[...choices].every(([id,count])=>Number.isSafeInteger(count*multiplier)&&physical.get(id)===count*multiplier);
    if(prices.size!==choices.size||(!matches(1)&&!matches(quantity)))throw Error('quantity');
    let reference=0;
    for(const[id,count]of choices){reference+=prices.get(id)*count*quantity;if(!Number.isSafeInteger(reference))throw Error('reference');}
    return reference-total;
  }
  class LBBKitSummary extends HTMLElement{
    connectedCallback(){requestAnimationFrame(()=>this.prepare());}
    prepare(){
      this.hidden=true;
      const referenceRow=this.querySelector('[data-kit-reference-total]');
      referenceRow.hidden=true;
      try{
        const cartTotal=integer(this.dataset.cartTotal),discounts=integer(this.dataset.cartDiscounts);
        if(cartTotal===null||discounts===null)throw Error('cart');
        const lines=Array.from(this.querySelectorAll('[data-kit-reference]')),keys=new Set();
        let savings=0,complete=true;
        for(const line of lines){
          const key=line.dataset.lineKey;
          if(!key||keys.has(key)){complete=false;continue;}
          keys.add(key);
          try{
            const saving=lineSavings(line);
            if(saving<0){complete=false;continue;}
            savings+=saving;
          }catch(_){complete=false;}
        }
        if(!Number.isSafeInteger(savings)||savings<=0) return;
        const money=new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency});
        this.querySelector('[data-kit-savings-label]').textContent=this.dataset.savingsLabel.replace('[amount]',money.format(savings/100));
        const referenceTotal=cartTotal+savings;
        // Cart discounts can change at a different basket value; do not invent that counterfactual.
        if(complete&&discounts===0&&this.dataset.hasLegacyKit!=='true'&&Number.isSafeInteger(referenceTotal)){
          this.querySelector('[data-kit-reference-amount]').textContent=money.format(referenceTotal/100);
          referenceRow.hidden=false;
        }
        this.dataset.savingsTotal=String(savings);
        this.hidden=false;
      }catch(_){}
    }
  }
  customElements.define('lbb-cart-kit-summary',LBBKitSummary);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-cart-shipping"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('lbb-shipping-reward')) return;
    let previousState = null, previousProgress = null;
    customElements.define('lbb-shipping-reward', class extends HTMLElement {
      connectedCallback() {
        const state = this.dataset.shippingState;
        const progress = Number(this.dataset.shippingProgress);
        const eligible = (state === 'pending' || state === 'reached') && Number.isFinite(progress) && progress >= 0 && progress <= 100;
        const crossedThreshold = previousState === 'pending' && state === 'reached';
        const fromProgress = previousProgress;
        previousState = eligible ? state : null;
        previousProgress = eligible ? progress : null;
        if (!eligible || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        requestAnimationFrame(() => {
          if (!this.isConnected || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          const fill = this.querySelector('.lbb-cart-shipping__fill');
          if (fromProgress !== null && fromProgress !== progress && fill && typeof fill.animate === 'function') {
            fill.animate([{ width: fromProgress + '%' }, { width: progress + '%' }], { duration: 420, easing: 'ease-out' });
          }
          if (crossedThreshold) this.classList.add('lbb-cart-shipping--celebrate');
        });
      }
      disconnectedCallback() {
        queueMicrotask(() => {
          if (!document.querySelector('lbb-shipping-reward')) {
            previousState = null;
            previousProgress = null;
          }
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-hair-kit-ui"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('lbb-hair-kit-ui-config');
    if (!config || config.dataset.initialized === 'true') return;
    config.dataset.initialized = 'true';
    const entities = { '&amp;': '&', '&quot;': '"', '&apos;': "'", '&#39;': "'", '&#x27;': "'", '&lt;': '<', '&gt;': '>' };
    const text = Object.fromEntries(Object.entries(config.dataset).map(([key, value]) => [key, String(value).replace(/&(?:amp|quot|apos|#39|#x27|lt|gt);/gi, entity => entities[entity.toLowerCase()])]));
    const labels = [text.stepShampoo, text.stepConditioner, text.stepMask, text.stepLeavein, text.stepFragrance];
    const descriptions = [text.descShampoo, text.descConditioner, text.descMask, text.descLeavein, text.descFragrance];
    // Matches the 32 approved variants on 2026-09-30. Catalogue changes require this allowlist to be reviewed.
    const allowedVariants = new Set((config.dataset.allowedVariants || '').split(',').filter(id => /^[1-9]\d*$/.test(id)));
    const stepCount = 5;
    const mobile = matchMedia('(max-width: 767px)');
    let currentRoot, currentCart, allowedNative, navigation, edit;
    let navigationTimer = 0, editTimer = 0, initializationTimer = 0;
    let scheduled = false, expanded = false, initializing = true, feedback = '';
    let submitting = false, loadingSeen = false, requestSeen = false, succeeded = false, confirmedError = false, token = 0;
    let chatStyle = null;
    const rootOf = () => document.getElementById('bundlesuiteContainer');
    const numberOf = node => /^\d+$/.test(node?.dataset.sectionIndex || '') ? Number(node.dataset.sectionIndex) : -1;
    const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
    const setAttr = (node, name, value) => { if (node.getAttribute(name) !== value) node.setAttribute(name, value); };
    const enabled = button => button && !button.disabled && !button.classList.contains('disabled') && !button.classList.contains('loading') && button.getAttribute('aria-disabled') !== 'true';
    // requirements-not-met marks the highest discount tier, not the configured checkout minimum.
    const checkoutEnabled = button => button?.matches('.side-cart-checkout-cta button') && enabled(button);
    const snapshot = root => {
      const sections = Array.from(root.querySelectorAll('.individual-products-section[data-section-index]')).sort((a, b) => numberOf(a) - numberOf(b));
      const tabs = Array.from(root.querySelectorAll('.condition-link[data-section-index]')).sort((a, b) => numberOf(a) - numberOf(b));
      const rows = Array.from(root.querySelectorAll('.sc-product-item[data-variant-id]'));
      const selected = new Map();
      let valid = allowedVariants.size > 0 && sections.length === stepCount && tabs.length === stepCount, units = 0, stale = false;
      sections.forEach((section, index) => { if (numberOf(section) !== index || numberOf(tabs[index]) !== index) valid = false; });
      rows.forEach(row => {
        const id = row.dataset.variantId;
        const raw = row.querySelector('.scpt-price-quantity')?.textContent.trim() || '';
        const quantity = Number(raw);
        if (!/^[1-9]\d*$/.test(id || '') || selected.has(id) || !/^[1-9]\d*$/.test(raw) || !Number.isSafeInteger(quantity)) valid = false;
        if (!allowedVariants.has(id)) { valid = false; stale = true; }
        selected.set(id, quantity);
        if (!row.querySelector('.scpt-gift-label')) units += quantity;
      });
      if (!Number.isSafeInteger(units)) valid = false;
      const active = tabs.filter(tab => tab.classList.contains('active'));
      const index = active.length === 1 ? numberOf(active[0]) : -1;
      if (index < 0 || index >= stepCount) valid = false;
      const signature = [...selected].sort(([a], [b]) => a.localeCompare(b)).map(([id, quantity]) => id + ':' + quantity).join('|');
      return { root, sections, tabs, rows, selected, units, index, signature, valid, stale };
    };
    const make = (tag, className, content) => { const node = document.createElement(tag); node.className = className; if (content) node.textContent = content; if (tag === 'button') node.type = 'button'; return node; };
    const stop = event => { event.preventDefault(); event.stopImmediatePropagation(); };
    const nativeClick = button => {
      const checkout = button.matches('.side-cart-checkout-cta button');
      if (checkout) { config.dataset.nativeCheckoutClick = 'dispatching'; config.dataset.nativeCheckoutCapture = 'not-observed'; }
      allowedNative = button;
      try { button.click(); }
      finally { allowedNative = null; if (checkout) config.dataset.nativeCheckoutClick = 'returned'; }
    };
    const clearNavigation = () => { navigation = null; clearTimeout(navigationTimer); navigationTimer = 0; };
    const clearEdit = () => { edit = null; clearTimeout(editTimer); editTimer = 0; };
    const focusStep = section => { if (!section?.getClientRects().length) return; const heading = section.querySelector('.section-title') || section; setAttr(heading, 'tabindex', '-1'); heading.focus({ preventScroll: true }); section.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); };
    const goTo = (state, index) => {
      if (!state.valid || !Number.isInteger(index) || index < 0 || index >= stepCount) return false;
      if (index === state.index) { focusStep(state.sections[index]); return true; }
      const direction = index > state.index ? 1 : -1;
      const button = Array.from(state.root.querySelectorAll(direction > 0 ? '.bundle-step-button.next-step' : '.bundle-step-button.prev-step')).find(enabled);
      if (!button) return false;
      clearNavigation();
      const operation = { root: state.root, target: index, from: state.index, expected: state.index + direction };
      navigation = operation; expanded = false; feedback = '';
      nativeClick(button);
      navigationTimer = setTimeout(() => { if (navigation === operation) { clearNavigation(); feedback = text.configurationError; schedule(); } }, 2000);
      schedule(); return true;
    };
    const review = () => { expanded = true; schedule(); requestAnimationFrame(() => { const panel = currentCart?.querySelector('.lbb-hair-kit-controls'); if (panel) { setAttr(panel, 'tabindex', '-1'); panel.focus({ preventScroll: true }); panel.scrollIntoView({ block: 'nearest' }); } }); };
    const nextStep = state => { if (state.index === stepCount - 1) { if (window.LBBLissageKitEdit?.active) submitKit(state); else review(); } else if (!goTo(state, state.index + 1)) { feedback = text.configurationError; schedule(); } };
    const actionsFor = (host, className, actions, index) => {
      let group = host.querySelector('.' + className);
      if (group) return group;
      group = make('div', className + ' lbb-hair-kit-actions');
      for (const action of actions) { const button = make('button', 'lbb-hair-kit-' + action); button.dataset.hairKitAction = action; if (index !== undefined) button.dataset.hairKitSectionIndex = String(index); setAttr(button, 'aria-describedby', 'lbb-hair-kit-status'); group.append(button); }
      return group;
    };
    const controlsFor = cart => {
      let controls = cart.querySelector('.lbb-hair-kit-controls'); if (controls) return controls;
      controls = make('div', 'lbb-hair-kit-controls'); controls.append(make('span', 'lbb-hair-kit-progress'), make('span', 'lbb-hair-kit-count'));
      const status = make('p', 'lbb-hair-kit-status'); status.id = 'lbb-hair-kit-status'; setAttr(status, 'role', 'status'); setAttr(status, 'aria-live', 'polite'); controls.append(status);
      controls.append(actionsFor(controls, 'lbb-hair-kit-summary-actions', ['previous', 'skip', 'submit'])); cart.append(controls); return controls;
    };
    const setNativeLabel = (node, value) => {
      if (!node || !value) return;
      const leaves = Array.from(node.childNodes || []).filter(child => child.nodeType === 3 && child.textContent.trim());
      if (leaves.length === 1) setText(leaves[0], value);
      else if (!node.children?.length) setText(node, value);
    };
    const localizeNativeControls = root => {
      for (const [selector, label] of [['.subtotal-text', text.subtotalLabel || text.subtotal], ['.discount-text', text.discountLabel || text.discount], ['.additional-text', text.discountLabel || text.discount], ['.total-text', text.totalLabel || text.total]]) {
        root.querySelectorAll('.side-cart-checkout-wrapper ' + selector).forEach(node => setNativeLabel(node, label));
      }
      root.querySelectorAll('.cart-empty').forEach(node => setNativeLabel(node, text.emptyKit));
      root.querySelectorAll('.cart-totoal-added-products p').forEach(node => {
        const counter = node.querySelector('.added-products-count');
        const raw = counter ? counter.textContent.trim() : node.textContent.trim().match(/^(\d+)\s+/)?.[1];
        if (!/^\d+$/.test(raw || '') || !Number.isSafeInteger(Number(raw))) return;
        const label = Number(raw) === 1 ? text.nativeItemOne : text.nativeItemMany;
        setNativeLabel(node, counter ? ' ' + label : raw + ' ' + label);
      });
      document.querySelectorAll('.product-variant-selector-cta button').forEach(button => {
        if (button.classList.contains('loading') || button.dataset.preOrder === 'true') return;
        const label = button.dataset.stockStatus === 'out-of-stock' || /^(?:out of stock|sold out|unavailable|indisponible|rupture de stock|épuisé)$/i.test(button.textContent.trim())
          ? text.unavailable : button.dataset.stockStatus === 'in-stock' || /^(?:add to (?:cart|bundle)|ajouter au (?:panier|kit)|choisir)$/i.test(button.textContent.trim()) ? text.addProduct : null;
        if (label) { setNativeLabel(button, label); setAttr(button, 'aria-label', label); }
      });
      const scopes = [root, ...document.querySelectorAll('.product-variant-selector')];
      scopes.forEach(scope => {
        scope.querySelectorAll('.close-variant-selector button').forEach(button => { setAttr(button, 'aria-label', text.close); setAttr(button, 'title', text.close); });
        for (const [selector, label] of [['.quantity-input', text.quantity], ['.quantity-btn.plus', text.increase], ['.quantity-btn.minus', text.decrease], ['.remove-item-btn', text.remove]]) {
          scope.querySelectorAll(selector).forEach(node => {
            const holder = node.closest('.sc-product-item, .product-card, .product-variant-selector');
            const title = holder?.querySelector('.scpt-title h4, .product-title h4, .product-variant-selector-header-title h3')?.textContent.replace(/\s+/g, ' ').trim();
            setAttr(node, 'aria-label', label + (title ? ' : ' + title : ''));
          });
        }
        scope.querySelectorAll('[aria-label]').forEach(node => {
          const label = node.getAttribute('aria-label');
          if (/^(?:regular price|prix normal|prix habituel)$/i.test(label)) setAttr(node, 'aria-label', text.regularPrice);
          else if (/^(?:sale price|prix réduit|prix promotionnel)$/i.test(label)) setAttr(node, 'aria-label', text.salePrice);
          else if (/^view product$/i.test(label)) setAttr(node, 'aria-label', text.viewProduct);
        });
      });
      document.body.querySelectorAll('[aria-label]').forEach(node => {
        const label = node.getAttribute('aria-label');
        if (/^previous slide$/i.test(label)) setAttr(node, 'aria-label', text.previousSlide);
        else if (/^next slide$/i.test(label)) setAttr(node, 'aria-label', text.nextSlide);
      });
      document.querySelectorAll('.bundle-toast.success .bundle-toast-message').forEach(node => {
        const message = node.textContent.trim();
        if (message === text.addedToCart) return;
        if (/^(?:(?:product|item) )?added to cart[.!]?$/i.test(message)) setNativeLabel(node, text.addedToCart);
        else if (/^Added .+ to bundle[.!]?$/i.test(message) || /^.+ ajout[ée]e? (?:au|dans le) (?:kit|panier|bundle)[.!]?$/i.test(message)) setNativeLabel(node, text.productAdded);
        else if (/^Removed .+ from bundle[.!]?$/i.test(message) || /^.+ retir[ée]e? (?:du|de votre) (?:kit|panier|bundle)[.!]?$/i.test(message)) setNativeLabel(node, text.productRemoved);
      });
    };
    const showKnownFormat = root => {
      // Tanino has one approved format here; native single-variant cards omit its label.
      const variantId = '56404346929417';
      root.querySelectorAll('.product-card[data-product-id]').forEach(card => {
        const id = String(card.dataset.productId).replace(/^gid:\/\/shopify\/(?:Product|ProductVariant)\//, '');
        if (id !== '15413508866313' && id !== variantId) return;
        let label = card.querySelector('.lbb-hair-kit-format');
        const title = card.querySelector('.product-title');
        const nativeText = (title?.querySelector('h4')?.textContent || '') + ' ' + (card.querySelector('.product-card-mid')?.textContent || '');
        const selector = card.querySelector('.product-variant-dropdowns, .custom-variant-dropdown, .product-variant-pills, select');
        const variantIds = Array.from(card.querySelectorAll('.quantity-controls[data-variant-id]')).map(node => node.dataset.variantId).filter(Boolean);
        const show = title && allowedVariants.has(variantId) && !selector && !/\b(?:200|500)\s*g\b/i.test(nativeText)
          && variantIds.every(value => value === variantId);
        if (!show) { label?.remove(); return; }
        if (!label) { label = make('p', 'lbb-hair-kit-format', '500 g'); title.append(label); }
      });
    };
    const labelProductControls = (root, rows) => {
      const clean = value => (value || '').replace(/\s+/g, ' ').trim();
      const rowsByVariant = new Map(rows.map(row => [row.dataset.variantId, row]));
      const cardsByVariant = new Map();
      root.querySelectorAll('.product-card .quantity-controls[data-variant-id]').forEach(control => {
        if (control.dataset.variantId) cardsByVariant.set(control.dataset.variantId, control.closest('.product-card'));
      });
      for (const [selector, action] of [['.quantity-input', text.quantity], ['.quantity-btn.plus', text.increase], ['.quantity-btn.minus', text.decrease], ['.remove-item-btn', text.remove]]) {
        root.querySelectorAll(selector).forEach(node => {
          const row = node.closest('.sc-product-item') || rowsByVariant.get(node.closest('.quantity-controls')?.dataset.variantId);
          const card = node.closest('.product-card') || cardsByVariant.get(row?.dataset.variantId);
          const title = clean(row?.querySelector('.scpt-title h4')?.textContent || card?.querySelector('.product-title h4')?.textContent);
          const format = clean(row?.querySelector('.scpt-variant p')?.textContent || card?.querySelector('.lbb-hair-kit-format')?.textContent);
          const includesFormat = title.replace(/\s/g, '').toLowerCase().includes(format.replace(/\s/g, '').toLowerCase());
          const context = title + (title && format && !includesFormat ? ' · ' + format : '');
          setAttr(node, 'aria-label', action + (context ? ' : ' + context : ''));
        });
      }
    };
    const updateSpace = () => {
      const active = mobile.matches && !!currentRoot && !!currentCart;
      for (const [name, value] of [['lbb-hair-kit-mobile', active], ['lbb-hair-kit-expanded', active && expanded]]) {
        if (document.documentElement.classList.contains(name) !== value) document.documentElement.classList.toggle(name, value);
      }
      const height = active ? Math.ceil(currentCart.getBoundingClientRect().height) : 0;
      if (active && !expanded && height > 0) currentRoot.style.setProperty('--lbb-hair-kit-space', height + 'px');
      const shadow = document.querySelector('shopify-chat')?.shadowRoot;
      if (chatStyle && (!active || expanded || chatStyle.parentNode !== shadow)) { chatStyle.remove(); chatStyle = null; }
      if (!active || expanded || !shadow) return;
      if (!chatStyle) { chatStyle = document.createElement('style'); shadow.append(chatStyle); }
      setText(chatStyle, '@media(max-width:767px){.activator-nudge{bottom:' + (Math.max(height, 140) + 12) + 'px!important;width:44px!important;max-width:44px!important;min-width:44px!important;height:44px!important;padding:0!important}.activator-nudge>button.activator[part="activator"]{width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;padding:0!important;gap:0!important}.activator__label{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important}}');
    };
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(updateSpace) : null;
    const resetSubmission = message => { submitting = false; loadingSeen = false; requestSeen = false; succeeded = false; confirmedError = false; token++; if (message) feedback = message; schedule(); };
    const render = () => {
      const root = rootOf(), cart = root?.querySelector('.side-cart-container');
      if (!root || !cart) { currentRoot = null; currentCart = null; updateSpace(); return; }
      if (currentRoot !== root) { currentRoot = root; clearNavigation(); clearEdit(); feedback = ''; expanded = false; resetSubmission(); }
      if (currentCart !== cart) { currentCart = cart; resize?.disconnect(); resize?.observe(cart); }
      root.classList.add('lbb-hair-kit');
      const tabsHost = root.querySelector('.condition-links-container');
      const title = root.querySelector('.template-top-data-header-title h2');
      if (title) setText(title, text.title);
      else if (tabsHost && !root.querySelector('.lbb-hair-kit-title')) tabsHost.before(make('h2', 'lbb-hair-kit-title', text.title));
      if (tabsHost && !root.querySelector('.lbb-hair-kit-instruction')) tabsHost.before(make('p', 'lbb-hair-kit-instruction', text.instruction));
      const state = snapshot(root);
      if (state.valid) { initializing = false; clearTimeout(initializationTimer); }
      else if (initializing && !initializationTimer) initializationTimer = setTimeout(() => { initializing = false; schedule(); }, 5000);
      if (edit && edit.signature !== state.signature) { clearEdit(); feedback = ''; }
      if (state.stale) expanded = true;
      if (navigation && state.valid) {
        const operation = navigation;
        if (state.index === operation.target) { clearNavigation(); focusStep(state.sections[state.index]); }
        else if (state.index === operation.expected) { clearNavigation(); if (!goTo(state, operation.target)) feedback = text.configurationError; }
        else if (state.index !== operation.from) { clearNavigation(); feedback = text.configurationError; }
      }
      const checkout = root.querySelector('.side-cart-checkout-cta button');
      if (confirmedError && checkout && !checkout.disabled && !checkout.classList.contains('disabled')) { checkout.classList.remove('loading'); resetSubmission(text.submitError); }
      const loading = !!checkout?.classList.contains('loading');
      if (submitting && loading) loadingSeen = true;
      if (submitting && loadingSeen && !loading && !requestSeen && !succeeded) resetSubmission(text.submitError);
      const cartEdit = window.LBBLissageKitEdit;
      const editBlocked = cartEdit?.active && (!cartEdit.ready || cartEdit.blocked || cartEdit.saving);
      const saveLabel = cartEdit?.active ? cartEdit.saveLabel : text.addKit;
      const reviewLabel = cartEdit?.active ? cartEdit.saveLabel : text.review;
      const busy = submitting || !!edit || !!navigation || !!editBlocked;
      const progress = index => text.categoryProgress.replace('[current]', String(Math.max(0, index) + 1)).replace('[total]', String(stepCount));
      const controls = controlsFor(cart);
      state.sections.forEach((section, index) => {
        setText(section.querySelector('.section-title'), labels[index] + ' · ' + text.optional);
        let description = section.querySelector('.condition-description');
        if (!description) { description = make('p', 'condition-description'); section.querySelector('.section-title')?.after(description); }
        setText(description, descriptions[index]);
        const grid = section.querySelector('.individual-products-container'); if (!grid) return;
        for (const position of ['top', 'bottom']) {
          const group = actionsFor(section, 'lbb-hair-kit-grid-nav-' + position, ['previous', 'next'], index);
          if (!group.parentElement) { if (position === 'top') grid.before(group); else grid.after(group); }
          setAttr(group, 'role', 'group'); setAttr(group, 'aria-label', progress(index));
          const previous = group.querySelector('.lbb-hair-kit-previous'), next = group.querySelector('.lbb-hair-kit-next');
          setText(previous, text.previous); previous.disabled = !state.valid || busy || index !== state.index || index === 0;
          setText(next, index === stepCount - 1 ? reviewLabel : text.next); next.disabled = !state.valid || busy || index !== state.index;
        }
      });
      state.tabs.forEach((tab, index) => { setText(tab, labels[index]); setAttr(tab, 'title', labels[index]); setAttr(tab, 'aria-disabled', busy ? 'true' : 'false'); });
      setText(controls.querySelector('.lbb-hair-kit-progress'), progress(state.index));
      setText(controls.querySelector('.lbb-hair-kit-count'), text.selectionCount.replace('[count]', String(state.units)));
      setText(controls.querySelector('.lbb-hair-kit-status'), state.stale ? text.staleSelection : feedback || (!state.valid ? initializing ? text.loading : text.configurationError : state.units < 2 ? text.minimum : ''));
      const previous = controls.querySelector('.lbb-hair-kit-previous'), skip = controls.querySelector('.lbb-hair-kit-skip'), submit = controls.querySelector('.lbb-hair-kit-submit');
      setText(previous, text.previous); previous.disabled = !state.valid || busy || state.index === 0;
      const activeSelected = state.sections[state.index]?.querySelectorAll('.quantity-controls[data-variant-id]');
      const hasSelected = Array.from(activeSelected || []).some(node => state.selected.has(node.dataset.variantId));
      setText(skip, state.index === stepCount - 1 ? reviewLabel : hasSelected ? text.next : text.skip); skip.disabled = !state.valid || busy;
      setText(submit, submitting ? text.adding : saveLabel); submit.disabled = !state.valid || state.units < 2 || busy || !checkoutEnabled(checkout);
      setAttr(root, 'aria-busy', submitting || (!state.valid && initializing) ? 'true' : 'false');
      setText(root.querySelector('.cart-head h3'), text.kitTitle);
      root.querySelectorAll('.bundle-step-description').forEach(node => setText(node, descriptions[state.index]));
      root.querySelectorAll('.bundle-step-condition').forEach(node => setText(node, text.optional));
      root.querySelectorAll('.product-card .add-button').forEach(button => {
        if (button.classList.contains('loading') || button.dataset.preOrder === 'true') return;
        const label = button.dataset.stockStatus === 'out-of-stock' ? text.unavailable : button.dataset.stockStatus === 'in-stock' ? text.addProduct : null;
        if (label) { setNativeLabel(button, label); setAttr(button, 'aria-label', label); }
      });
      localizeNativeControls(root);
      showKnownFormat(root);
      labelProductControls(root, state.rows);
      let toggle = cart.querySelector('.lbb-hair-kit-toggle');
      if (!toggle) { toggle = make('button', 'lbb-hair-kit-toggle'); toggle.dataset.hairKitAction = 'toggle'; const label = make('span', 'lbb-hair-kit-toggle-label'); label.append(make('strong', '', text.kitTitle), make('span', 'lbb-hair-kit-toggle-action')); toggle.append(label, make('span', 'lbb-hair-kit-toggle-total')); cart.prepend(toggle); }
      setAttr(toggle, 'aria-expanded', mobile.matches && expanded ? 'true' : 'false');
      const panels = [];
      for (const [selector, suffix] of [['.side-cart-product-container', 'products'], ['.side-cart-checkout-wrapper', 'totals']]) { const panel = cart.querySelector(selector); if (panel) { if (!panel.id) panel.id = 'lbb-hair-kit-panel-' + suffix; panels.push(panel.id); } }
      setAttr(toggle, 'aria-controls', panels.join(' '));
      setText(toggle.querySelector('.lbb-hair-kit-toggle-action'), expanded ? text.collapse : text.details);
      setText(toggle.querySelector('.lbb-hair-kit-toggle-total'), state.units ? root.querySelector('.side-cart-checkout-wrapper .total-value')?.textContent.trim() || '' : '');
      cart.classList.toggle('lbb-hair-kit-open', mobile.matches && expanded); updateSpace();
    };
    const observer = new MutationObserver(() => schedule());
    const observe = () => observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'disabled', 'aria-disabled', 'data-variant-id', 'data-section-index', 'data-stock-status'] });
    function schedule() { if (scheduled) return; scheduled = true; requestAnimationFrame(() => { scheduled = false; observer.disconnect(); try { render(); } finally { observe(); } }); }
    const submitKit = state => {
      const cartEdit = window.LBBLissageKitEdit;
      if (cartEdit?.active) { if (state.valid && !edit && !navigation) cartEdit.save(); return; }
      if (submitting || edit || navigation) return;
      if (!state.valid) { feedback = text.configurationError; schedule(); return; }
      if (state.units < 2) { feedback = text.minimum; schedule(); return; }
      const buttons = Array.from(state.root.querySelectorAll('.side-cart-checkout-cta button')).filter(checkoutEnabled);
      if (buttons.length !== 1) { feedback = text.configurationError; schedule(); return; }
      const operation = ++token; submitting = true; requestSeen = false; succeeded = false; confirmedError = false; loadingSeen = false; feedback = '';
      config.dataset.checkoutAttempts = String((Number(config.dataset.checkoutAttempts) || 0) + 1);
      config.dataset.cartRequestState = 'not-observed'; config.dataset.cartHttpStatus = '';
      nativeClick(buttons[0]); loadingSeen = buttons[0].classList.contains('loading'); schedule();
      setTimeout(() => { if (operation === token && !loadingSeen && !requestSeen && !succeeded) resetSubmission(text.submitError); }, 1500);
    };
    document.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const root = rootOf(), popup = target?.closest('.product-variant-selector-cta button');
      if (!root || !target || (!root.contains(target) && !popup)) return;
      if (allowedNative && (target === allowedNative || allowedNative.contains(target))) {
        if (allowedNative.matches('.side-cart-checkout-cta button')) config.dataset.nativeCheckoutCapture = 'allowed';
        return;
      }
      const cartEdit = window.LBBLissageKitEdit;
      if (cartEdit?.active && (!cartEdit.ready || cartEdit.blocked || cartEdit.saving)) { stop(event); return; }
      const state = snapshot(root), custom = target.closest('[data-hair-kit-action]');
      if (custom) {
        stop(event); const action = custom.dataset.hairKitAction;
        if (action === 'toggle') { expanded = !expanded; schedule(); return; }
        if (custom.disabled || submitting || navigation || edit) return;
        if (custom.dataset.hairKitSectionIndex !== undefined && Number(custom.dataset.hairKitSectionIndex) !== state.index) return;
        if (action === 'submit') submitKit(state);
        else if (action === 'previous') { feedback = ''; goTo(state, state.index - 1); }
        else if (action === 'next' || action === 'skip') nextStep(state);
        return;
      }
      const final = target.closest('.side-cart-checkout-cta button'), next = target.closest('.bundle-step-button.next-step'), previous = target.closest('.bundle-step-button.prev-step'), tab = target.closest('.condition-link[data-section-index]');
      if (final || next || previous || tab) { stop(event); if (submitting || navigation || edit) return; if (final) submitKit(state); else if (next) nextStep(state); else if (!goTo(state, previous ? state.index - 1 : numberOf(tab))) { feedback = text.configurationError; schedule(); } return; }
      const nativeEdit = popup || target.closest('.add-button, .quantity-btn, .remove-item-btn');
      if (!nativeEdit) return;
      const remove = nativeEdit.matches('.remove-item-btn');
      if (submitting || navigation || (edit && !popup) || (!state.valid && !remove) || !enabled(nativeEdit)) { stop(event); return; }
      clearEdit(); feedback = ''; edit = { signature: state.signature };
      editTimer = setTimeout(() => { clearEdit(); schedule(); }, 8000); schedule();
      // Native handlers own quantities, stock, totals and selections. Never advance after an edit.
    }, true);
    document.addEventListener('lbb:hair-kit-cart-request', event => { const state = event.detail?.state; if (state === 'pending') { submitting = true; requestSeen = true; clearEdit(); } else if (state === 'success') { submitting = true; requestSeen = true; succeeded = true; } else if (state === 'error') { confirmedError = true; feedback = text.submitError; } schedule(); });
    document.addEventListener('lbb:lissage-kit-cart-request', event => { const state = event.detail?.state; if (state === 'pending') { submitting = true; requestSeen = true; clearEdit(); } else if (state === 'success') { submitting = true; requestSeen = true; succeeded = true; } else if (state === 'error') { confirmedError = true; feedback = text.submitError; } schedule(); });
    window.addEventListener('pageshow', event => { if (event.persisted) { clearNavigation(); clearEdit(); resetSubmission(); } });
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && expanded) { expanded = false; schedule(); currentCart?.querySelector('.lbb-hair-kit-toggle')?.focus(); } });
    mobile.addEventListener('change', () => { expanded = false; schedule(); });
    observe(); schedule();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-kit-advanced-i18n"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('lbb-kit-advanced-i18n-config');
    if (!config || config.dataset.initialized === 'true') return;
    let data;
    try { data = JSON.parse(config.textContent); } catch (_) { return; }
    if (!data || typeof data.title !== 'string' || !data.variants || Array.isArray(data.variants)) return;
    config.dataset.initialized = 'true';
    const entities = { '&amp;': '&', '&quot;': '"', '&apos;': "'", '&#39;': "'", '&#x27;': "'", '&lt;': '<', '&gt;': '>' };
    const decode = value => typeof value === 'string' ? value.replace(/&(?:amp|quot|apos|#39|#x27|lt|gt);/gi, entity => entities[entity.toLowerCase()]) : '';
    ['viewProduct', 'previousSlide', 'nextSlide', 'addedToCart', 'lissage', 'mask', 'includedShampoo'].forEach(key => { data[key] = decode(data[key]); });
    const normalize = value => String(value || '').replace(/\s+/g, ' ').trim();
    const compact = value => normalize(value).toLocaleLowerCase().replace(/[\s\u2010-\u2015-]/g, '');
    const cleanId = value => {
      const id = String(value || '').replace(/^gid:\/\/shopify\/ProductVariant\//, '');
      return /^\d+$/.test(id) ? id : '';
    };
    const setText = (node, value) => {
      if (!node || typeof value !== 'string' || node.textContent === value) return false;
      node.textContent = value;
      return true;
    };
    const setAttr = (node, key, value) => {
      if (!node || typeof value !== 'string' || node.getAttribute(key) === value) return false;
      node.setAttribute(key, value);
      return true;
    };
    const cardTitle = entry => {
      if (entry.defaultOnly || !entry.variant || /^(?:default title|titre par défaut)$/i.test(entry.variant) || compact(entry.title).includes(compact(entry.variant))) return entry.title;
      return entry.title + ' — ' + entry.variant;
    };
    const headings = new Map([
      ['votre lissage', data.lissage],
      ['votre masque', data.mask],
      ['shampooing anti-résidus inclus', data.includedShampoo],
      ['shampoing anti-résidus inclus', data.includedShampoo]
    ]);
    const localizeLink = (link, entry) => {
      try {
        const current = new URL(link.getAttribute('href'), location.origin);
        const localized = new URL(entry.url, location.origin);
        const handle = current.pathname.match(/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/products\/([a-z0-9][a-z0-9-]*)\/?$/i)?.[1];
        if (current.origin === location.origin && localized.origin === location.origin && handle === entry.handle) setAttr(link, 'href', localized.pathname + current.search + current.hash);
      } catch (_) {}
    };
    let queued = false;
    const options = { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-value', 'title'] };
    const render = () => {
      queued = false;
      const root = document.getElementById('bundlerAppProducts');
      if (!root) return;
      observer.disconnect();
      try {
        root.classList.add('lbb-kit-advanced-i18n');
        document.body.querySelectorAll('[aria-label]').forEach(node => {
          const label = normalize(node.getAttribute('aria-label'));
          if (/^previous slide$/i.test(label) && data.previousSlide) setAttr(node, 'aria-label', data.previousSlide);
          else if (/^next slide$/i.test(label) && data.nextSlide) setAttr(node, 'aria-label', data.nextSlide);
        });
        document.body.querySelectorAll('.bundle-toast.success .bundle-toast-message').forEach(node => {
          if (/^(?:(?:product|item) )?added to cart[.!]?$/i.test(normalize(node.textContent)) && data.addedToCart && !node.children.length) setText(node, data.addedToCart);
        });
        if (!data.isDuo) {
          root.querySelectorAll('.bundle-title').forEach(node => setText(node, data.title));
          root.querySelectorAll('.bundle-product-title').forEach(node => {
            const label = headings.get(normalize(node.textContent).toLocaleLowerCase());
            if (label) setText(node, label);
          });
        }
        let labelsChanged = false;
        let localizedCards = 0;
        let unmappedCards = 0;
        root.querySelectorAll('.bundle-variant-card[data-value]').forEach(card => {
          const entry = data.variants[cleanId(card.getAttribute('data-value'))];
          if (!entry || typeof entry.title !== 'string' || !entry.title) { unmappedCards++; return; }
          const title = cardTitle(entry);
          localizedCards++;
          if (setText(card.querySelector('.bundle-card-title'), title)) labelsChanged = true;
          if (setAttr(card, 'title', title)) labelsChanged = true;
          card.querySelectorAll('img').forEach(image => setAttr(image, 'alt', title));
          card.querySelectorAll('.bundle-view-icon').forEach(button => setAttr(button, 'aria-label', data.viewProduct.replace('__TITLE__', title)));
          card.querySelectorAll('a[href]').forEach(link => localizeLink(link, entry));
        });
        setAttr(root, 'data-lbb-advanced-localized', String(localizedCards));
        setAttr(root, 'data-lbb-advanced-unmapped', String(unmappedCards));
        if (labelsChanged) root.dispatchEvent(new CustomEvent('lbb:advanced-kit-localized'));
      } finally {
        observer.observe(document.body, options);
      }
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(render); } };
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, options);
    render();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-kit-brand-choice"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('[data-lbb-kit-brand-choice]').forEach((root) => {
        if (root.dataset.brandReady) return;
        root.dataset.brandReady = 'true';
        const lifecycle = new AbortController();
        const listenerOptions = { signal: lifecycle.signal };
        const guide = root.closest('[data-lissage-compact]');
        const buttons = [...root.querySelectorAll('[data-lbb-choose-brand]')];
        const panels = [...root.querySelectorAll('[data-lbb-brand-panel]')];
        const brands = new Set(buttons.map((button) => button.dataset.lbbChooseBrand));
        const syncBrand = (focus = false) => {
          const params = new URLSearchParams(location.search);
          const requested = params.get('lbb_brand');
          const brand = params.get('lbb_offer') === 'build' && !params.has('lbb_formula') && brands.has(requested) ? requested : '';
          panels.forEach((panel) => { panel.hidden = panel.dataset.lbbBrandPanel !== brand; });
          buttons.forEach((button) => button.setAttribute('aria-expanded', String(button.dataset.lbbChooseBrand === brand)));
          if (brand && guide) { delete guide.dataset.lbbFormula; guide.dataset.lbbOffer = 'build'; }
          if (focus) {
            const target = brand ? panels.find((panel) => panel.dataset.lbbBrandPanel === brand)?.querySelector('h2') : buttons[0];
            target?.focus({ preventScroll: true });
            (brand ? target?.closest('[data-lbb-brand-panel]') : root.querySelector('#composer-mon-kit-lissage'))?.scrollIntoView({ block: 'start', behavior: 'auto' });
          }
        };
        const changeBrand = (brand) => {
          const url = new URL(location.href);
          url.searchParams.delete('lbb_formula');
          url.searchParams.delete('lbb_start_variant');
          url.searchParams.set('lbb_offer', 'build');
          if (brand) url.searchParams.set('lbb_brand', brand);
          else url.searchParams.delete('lbb_brand');
          url.hash = brand ? panels.find((panel) => panel.dataset.lbbBrandPanel === brand).id : 'composer-mon-kit-lissage';
          history.pushState(null, '', url);
          if (guide) { delete guide.dataset.lbbFormula; guide.dataset.lbbOffer = 'build'; }
          syncBrand(true);
        };
        root.addEventListener('click', (event) => {
          const brandButton = event.target.closest('[data-lbb-choose-brand]');
          if (brandButton && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
            event.preventDefault();
            changeBrand(brandButton.dataset.lbbChooseBrand);
          }
          if (event.target.closest('[data-lbb-change-brand]')) { event.preventDefault(); changeBrand(''); }
          if (event.target.closest('[data-lbb-compose][aria-disabled="true"]')) event.preventDefault();
          if (event.target.closest('[data-lissage-show-ready]')) {
            requestAnimationFrame(() => {
              const url = new URL(location.href);
              url.searchParams.delete('lbb_brand');
              history.replaceState(history.state, '', url);
              syncBrand();
            });
          }
        }, listenerOptions);
        const selectFormat = (choice) => {
          if (!choice || choice.disabled || !choice.checked || !choice.dataset.url) return;
          const card = choice.closest('[data-lbb-brand-product]');
          const compose = card.querySelector('[data-lbb-compose]');
          const url = new URL(choice.dataset.url, location.origin);
          if (!['https:', 'http:'].includes(url.protocol)) return;
          compose.href = url.href;
          compose.setAttribute('aria-disabled', 'false');
          compose.removeAttribute('tabindex');
          const status = card.querySelector('[data-lbb-format-status]');
          status.textContent = status.dataset.selectedTemplate.replace('[format]', choice.dataset.format);
          const image = card.querySelector('.lbb-kit-brand-card__image img');
          if (image && choice.dataset.imageSrc) {
            image.srcset = choice.dataset.imageSrcset || '';
            image.src = choice.dataset.imageSrc;
            image.alt = choice.dataset.imageAlt;
          }
        };
        root.addEventListener('change', (event) => selectFormat(event.target.closest('[data-lbb-format-choice]')), listenerOptions);
        const restoreFormats = () => root.querySelectorAll('[data-lbb-format-choice]:checked').forEach(selectFormat);
        restoreFormats();
        syncBrand();
        window.addEventListener('popstate', () => syncBrand(true), listenerOptions);
        window.addEventListener('pageshow', restoreFormats, listenerOptions);
        guide?.addEventListener('click', (event) => {
          if (event.target.closest('[data-lissage-reset]')) requestAnimationFrame(() => syncBrand());
        }, listenerOptions);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(root)) { lifecycle.abort(); root.dataset.brandReady = ''; }
        }, listenerOptions);
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-kit-formula-ui"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('lbb-kit-formula-ui-config');
    if (!config || config.dataset.initialized === 'true') return;
    config.dataset.initialized = 'true';
    const text = config.dataset;
    const knownChoiceLabels = new Set([
      'Choix effectué', 'Choice made', 'Selection made', 'Selected',
      text.selected, text.otherChoice
    ]);
    const unavailableLabel = /indisponible|rupture|épuisé|sold\s*out|out\s*of\s*stock|unavailable/i;
    let pending = false;
    const removingVariants = new Map();
    const removalFor = (root, variantId) => {
      const rows = Array.from(root.querySelectorAll('.sc-product-item[data-variant-id]'))
        .filter(row => row.dataset.variantId === variantId);
      if (rows.length !== 1) return null;
      const action = rows[0].querySelector('.remove-item-btn');
      return action && !action.disabled && !action.classList.contains('disabled')
        && action.getAttribute('aria-disabled') !== 'true' ? action : null;
    };
    const setText = (element, value) => {
      if (element && element.textContent !== value) element.textContent = value;
    };
    const applyPresentation = () => {
      const root = document.getElementById('bundlesuiteContainer');
      if (!root) return;
      root.classList.add('lbb-kit-formula-ui');
      let back = document.getElementById('lbb-kit-formula-ui-back');
      if (!back) {
        back = document.createElement('a');
        back.id = 'lbb-kit-formula-ui-back';
        back.className = 'lbb-kit-formula-ui-back';
        back.href = text.returnUrl;
        back.textContent = text.back;
        root.before(back);
      }
      const stepLinks = root.querySelector('.condition-links-container');
      if (stepLinks && !root.querySelector('.lbb-kit-formula-ui-step-note')) {
        const stepNote = document.createElement('p');
        stepNote.className = 'lbb-kit-formula-ui-note lbb-kit-formula-ui-step-note';
        stepNote.textContent = text.autoStepNote;
        stepLinks.before(stepNote);
      }
      const discountAnchor = stepLinks || root.querySelector('.individual-products-section[data-section-index]');
      if (text.discountNote && discountAnchor && !root.querySelector('.lbb-kit-formula-ui-discount-note')) {
        const discountNote = document.createElement('p');
        discountNote.className = 'lbb-kit-formula-ui-note lbb-kit-formula-ui-discount-note';
        discountNote.textContent = text.discountNote;
        discountAnchor.before(discountNote);
      }
      setText(root.querySelector('.side-cart-checkout-wrapper .subtotal-text'), text.subtotalLabel);
      setText(root.querySelector('.side-cart-checkout-wrapper .discount-text'), text.discountLabel);
      setText(root.querySelector('.side-cart-checkout-wrapper .total-text'), text.totalLabel);
      const checkout = root.querySelector('.side-cart-checkout-wrapper');
      if (text.country === 'FR' && text.currency === 'EUR' && text.shippingNote
        && checkout && !checkout.querySelector('.lbb-kit-formula-ui-shipping-note')) {
        const shippingNote = document.createElement('p');
        shippingNote.className = 'lbb-kit-formula-ui-note lbb-kit-formula-ui-shipping-note';
        shippingNote.textContent = text.shippingNote;
        checkout.append(shippingNote);
      }
      setText(root.querySelector('.cart-head h3'), text.title);
      const cartHead = root.querySelector('.cart-head');
      if (cartHead && !cartHead.querySelector('.lbb-kit-formula-ui-note')) {
        const note = document.createElement('p');
        note.className = 'lbb-kit-formula-ui-note';
        note.textContent = text.duoNote;
        cartHead.append(note);
      }
      const count = root.querySelector('.cart-totoal-added-products p');
      const countNumber = count && count.querySelector('.added-products-count');
      if (countNumber) {
        let suffix = null;
        for (const child of count.childNodes) {
          if (child.nodeType === Node.TEXT_NODE && child.previousSibling === countNumber) {
            suffix = child;
            break;
          }
        }
        if (suffix && suffix.textContent !== ' ' + text.count) suffix.textContent = ' ' + text.count;
      }
      const selectedVariants = new Set(
        Array.from(root.querySelectorAll('.sc-product-item[data-variant-id]'), row => row.dataset.variantId).filter(Boolean)
      );
      const removedChoices = [];
      removingVariants.forEach((operation, id) => {
        if (!selectedVariants.has(id)) {
          removingVariants.delete(id);
          removedChoices.push(operation);
        }
      });
      root.querySelectorAll('.product-card[data-product-id]').forEach(card => {
        const variants = Array.from(card.querySelectorAll('.quantity-controls[data-variant-id]'), control => control.dataset.variantId);
        const selected = variants.some(id => selectedVariants.has(id));
        card.classList.toggle('lbb-kit-formula-ui-selected', selected);
        card.querySelectorAll('.add-button.disabled').forEach(button => {
          const label = button.textContent.trim();
          if (unavailableLabel.test(label) || !knownChoiceLabels.has(label)) return;
          const controls = button.closest('.quantity-controls[data-variant-id]');
          const buttonSelected = controls ? selectedVariants.has(controls.dataset.variantId) : selected;
          setText(button, buttonSelected ? text.selected : text.otherChoice);
        });
        card.querySelectorAll('.add-button').forEach(button => {
          const controls = button.closest('.quantity-controls[data-variant-id]');
          const candidates = controls ? [controls.dataset.variantId] : variants;
          const selectedIds = [...new Set(candidates.filter(id => selectedVariants.has(id)))];
          const variantId = selectedIds.length === 1 ? selectedIds[0] : null;
          let remove = button.nextElementSibling;
          if (!remove?.classList.contains('lbb-kit-remove-choice')) remove = null;
          if (!variantId || !removalFor(root, variantId)) {
            button.removeAttribute('data-lbb-remove-replaced');
            remove?.remove();
            return;
          }
          button.setAttribute('data-lbb-remove-replaced', 'true');
          if (!remove) {
            remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'lbb-kit-remove-choice';
            button.after(remove);
          }
          remove.dataset.variantId = variantId;
          remove.disabled = removingVariants.has(variantId);
          setText(remove, text.removeChoice);
          const title = card.querySelector('.product-title h4')?.textContent.trim();
          remove.setAttribute('aria-label', text.removeChoice + (title ? ' : ' + title : ''));
        });
      });
      removedChoices.forEach(operation => {
        if (!operation.hadFocus || (document.activeElement !== document.body
          && document.activeElement !== operation.button)) return;
        const card = Array.from(root.querySelectorAll('.product-card[data-product-id]'))
          .find(candidate => candidate.dataset.productId === operation.productId
            && candidate.closest('.individual-products-section')?.dataset.sectionIndex === operation.sectionIndex);
        const choose = card?.querySelector('.add-button:not(:disabled):not(.disabled):not([aria-disabled="true"])');
        if (choose?.getClientRects().length) choose.focus({ preventScroll: true });
      });
    };
    const observer = new MutationObserver(() => {
      if (pending) return;
      pending = true;
      queueMicrotask(() => {
        pending = false;
        observer.disconnect();
        applyPresentation();
        observe();
      });
    });
    const observe = () => observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'data-variant-id', 'disabled']
    });
    applyPresentation();
    observe();

    let selectionJob = null;
    let selectionTimer = 0;
    let selectionFrame = 0;
    let ownNavigation = false;
    let cartSubmission = false;
    let submissionStarted = false;
    let submissionAttempt = 0;
    const expectedChoices = Number(text.expectedChoices);
    const getRoot = () => document.getElementById('bundlesuiteContainer');
    const sectionsOf = root => Array.from(root.querySelectorAll('.individual-products-section[data-section-index]'));
    const indexOf = element => {
      const value = element?.dataset.sectionIndex;
      return /^\d+$/.test(value || '') ? Number(value) : -1;
    };
    const activeIndex = root => {
      const active = root.querySelector('.condition-link.active[data-section-index]');
      if (active) return indexOf(active);
      const sections = sectionsOf(root);
      return sections.length === 1 && sections[0].getClientRects().length ? indexOf(sections[0]) : -1;
    };
    const sectionAt = (root, index) => sectionsOf(root).find(section => indexOf(section) === index);
    const selectedRows = root => Array.from(root.querySelectorAll('.sc-product-item[data-variant-id]'));
    const readyButton = button => button && button.getClientRects().length
      && !button.disabled && !button.classList.contains('disabled')
      && !button.classList.contains('loading')
      && !button.classList.contains('requirements-not-met')
      && button.getAttribute('aria-disabled') !== 'true';
    const completeSelection = root => {
      if (!Number.isInteger(expectedChoices) || expectedChoices < 1 || expectedChoices > 4) return false;
      const sections = sectionsOf(root);
      const rows = selectedRows(root);
      if (sections.length !== expectedChoices || rows.length !== expectedChoices) return false;
      const selected = new Set(rows.map(row => row.dataset.variantId).filter(Boolean));
      if (selected.size !== expectedChoices
        || rows.some(row => row.querySelector('.scpt-price-quantity')?.textContent.trim() !== '1')) return false;
      const covered = new Set();
      for (let index = 0; index < expectedChoices; index++) {
        const matches = sections.filter(section => indexOf(section) === index);
        if (matches.length !== 1) return false;
        const choices = new Set(Array.from(matches[0].querySelectorAll('.quantity-controls[data-variant-id]'),
          control => control.dataset.variantId).filter(id => selected.has(id)));
        if (choices.size !== 1) return false;
        const id = choices.values().next().value;
        if (covered.has(id)) return false;
        covered.add(id);
      }
      return covered.size === expectedChoices;
    };
    const finalAction = root => {
      if (root.querySelector('.side-cart-checkout-cta button.loading')) return null;
      const next = Array.from(root.querySelectorAll('.bundle-step-button.next-step')).filter(readyButton);
      if (next.length === 1) return next[0];
      const cart = Array.from(root.querySelectorAll('.side-cart-checkout-cta button')).filter(readyButton);
      return cart.length === 1 ? cart[0] : null;
    };
    const lockCartSubmission = () => {
      const attempt = ++submissionAttempt;
      cartSubmission = true;
      submissionStarted = false;
      // A native validation failure may stop before a request is made. Never retry it automatically.
      setTimeout(() => {
        if (attempt === submissionAttempt && !submissionStarted) cartSubmission = false;
      }, 1500);
    };
    document.addEventListener('lbb:kit-cart-request', event => {
      if (event.detail?.state === 'pending') {
        cartSubmission = true;
        submissionStarted = true;
        clearSelectionJob();
      } else if (event.detail?.state === 'error') {
        cartSubmission = false;
        submissionStarted = false;
        clearSelectionJob();
      }
      // Success stays locked while BundleSuite opens the cart in the selected language.
    });
    const clearSelectionJob = () => {
      selectionJob = null;
      clearTimeout(selectionTimer);
      selectionTimer = 0;
    };
    document.defaultView?.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      submissionAttempt++;
      cartSubmission = false;
      submissionStarted = false;
      clearSelectionJob();
    });
    const focusStep = target => {
      if (!target || !target.getClientRects().length) return;
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.classList.add('lbb-kit-formula-ui-step-focus');
      target.focus({ preventScroll: true });
      target.scrollIntoView({
        block: 'start',
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    };
    const scheduleSelectionCheck = () => {
      if (!selectionJob || selectionFrame) return;
      selectionFrame = requestAnimationFrame(() => {
        selectionFrame = 0;
        checkSelection();
      });
    };
    function checkSelection() {
      const job = selectionJob;
      if (!job) return;
      const root = getRoot();
      if (!root || root !== job.root) return clearSelectionJob();
      const currentIndex = activeIndex(root);
      if (job.phase === 'navigation') {
        if (currentIndex !== job.index && currentIndex !== job.nextIndex) return clearSelectionJob();
        if (currentIndex !== job.nextIndex) return;
        const nextSection = sectionAt(root, job.nextIndex);
        if (!nextSection || !nextSection.getClientRects().length) return;
        clearSelectionJob();
        focusStep(nextSection.querySelector('.section-title, h2, h3') || nextSection);
        return;
      }
      if (currentIndex !== job.index) return clearSelectionJob();
      const section = sectionAt(root, job.index);
      const card = section && Array.from(section.querySelectorAll('.product-card[data-product-id]'))
        .find(candidate => candidate.dataset.productId === job.productId);
      if (!card) return;
      const variants = new Set(Array.from(card.querySelectorAll('.quantity-controls[data-variant-id]'),
        control => control.dataset.variantId).filter(Boolean));
      const acceptedRow = selectedRows(root).find(row => variants.has(row.dataset.variantId)
        && !job.before.has(row.dataset.variantId)
        && row.querySelector('.scpt-price-quantity')?.textContent.trim() === '1');
      if (!acceptedRow) return;
      if (job.index === expectedChoices - 1) {
        if (window.LBBKitEdit?.active) { clearSelectionJob(); return; }
        if (cartSubmission || !completeSelection(root)) return;
        const action = finalAction(root);
        if (!action) return;
        clearSelectionJob();
        lockCartSubmission();
        ownNavigation = true;
        try {
          action.click();
        } finally {
          ownNavigation = false;
        }
        return;
      }
      const nextSection = sectionAt(root, job.index + 1);
      if (!nextSection) {
        clearSelectionJob();
        focusStep(root.querySelector('.cart-head h3'));
        return;
      }
      const next = Array.from(root.querySelectorAll('.bundle-step-button.next-step'))
        .find(button => button.getClientRects().length && !button.disabled
          && button.getAttribute('aria-disabled') !== 'true');
      if (!next) return;
      job.phase = 'navigation';
      job.nextIndex = job.index + 1;
      ownNavigation = true;
      try {
        next.click();
      } finally {
        ownNavigation = false;
      }
      scheduleSelectionCheck();
    }
    document.addEventListener('click', event => {
      if (ownNavigation || !event.isTrusted) return;
      clearSelectionJob();
      const root = getRoot();
      const target = event.target instanceof Element ? event.target : null;
      if (!root || !target || !root.contains(target)) return;
      const checkout = target.closest('.side-cart-checkout-cta button');
      const lastNext = target.closest('.bundle-step-button.next-step');
      if (checkout || (lastNext && activeIndex(root) === expectedChoices - 1)) {
        if (cartSubmission || root.querySelector('.side-cart-checkout-cta button.loading')) {
          event.preventDefault();
          event.stopImmediatePropagation();
        } else if (readyButton(checkout || lastNext) && completeSelection(root)) {
          lockCartSubmission();
        }
        return;
      }
      if (cartSubmission) return;
      const remove = target.closest('.lbb-kit-remove-choice');
      if (remove) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const variantId = remove.dataset.variantId;
        const card = remove.closest('.product-card[data-product-id]');
        const matchesCard = card && Array.from(card.querySelectorAll('.quantity-controls[data-variant-id]'))
          .some(control => control.dataset.variantId === variantId);
        const nativeRemove = matchesCard && removalFor(root, variantId);
        if (!nativeRemove || removingVariants.has(variantId)) return;
        const operation = {
          button: remove,
          hadFocus: document.activeElement === remove,
          productId: card.dataset.productId,
          sectionIndex: card.closest('.individual-products-section')?.dataset.sectionIndex
        };
        removingVariants.set(variantId, operation);
        remove.disabled = true;
        nativeRemove.click();
        setTimeout(() => {
          if (removingVariants.get(variantId) !== operation) return;
          removingVariants.delete(variantId);
          applyPresentation();
        }, 2000);
        return;
      }
      const add = target.closest('.add-button');
      if (!add || add.disabled || add.classList.contains('disabled')
        || add.getAttribute('aria-disabled') === 'true'
        || unavailableLabel.test(add.textContent)) return;
      const card = add.closest('.product-card[data-product-id]');
      const section = card?.closest('.individual-products-section[data-section-index]');
      const index = activeIndex(root);
      if (!card || !section || index < 0 || indexOf(section) !== index
        || !section.getClientRects().length || !card.dataset.productId) return;
      selectionJob = {
        phase: 'addition', root, index, productId: card.dataset.productId,
        before: new Set(selectedRows(root).map(row => row.dataset.variantId).filter(Boolean))
      };
      selectionTimer = setTimeout(clearSelectionJob, 8000);
      scheduleSelectionCheck();
    }, true);
    document.addEventListener('change', event => {
      if (event.isTrusted && selectionJob) clearSelectionJob();
    }, true);
    new MutationObserver(scheduleSelectionCheck).observe(document.documentElement, {
      childList: true, subtree: true, characterData: true, attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'disabled', 'aria-disabled', 'data-variant-id']
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-kit-i18n"] && !Shopify.designMode) return;
  try {
    (() => {
      const config = document.getElementById('lbb-kit-native-labels');
      if (!config || !document.getElementById('lbb-kit-formula-ui-config')) return;
      const data = JSON.parse(config.textContent), labels = data.labels;
      const stages = ['duo', 'mask', 'leavein', 'fragrance'];
      const setText = (node, value) => { if (node && value && node.textContent !== value) node.textContent = value; };
      const setAttr = (node, key, value) => { if (node && value && node.getAttribute(key) !== value) node.setAttribute(key, value); };
      const decode = value => {
        const node = document.createElement('textarea');
        node.innerHTML = String(value || '');
        return node.value;
      };
      const normalize = value => decode(value).replace(/\s+/g, ' ').trim();
      const entries = Object.values(data.titles || {});
      const aliases = new Map();
      const remember = (value, entry) => {
        const key = normalize(value);
        if (!key) return;
        if (!aliases.has(key)) aliases.set(key, entry);
        else if (aliases.get(key) !== entry) aliases.set(key, null);
      };
      entries.forEach(entry => { remember(entry.original, entry); remember(entry.title, entry); });
      const formatOf = value => normalize(value).match(/\s[-–—]\s(\d+(?:[.,]\d+)?\s*(?:kg|g|ml|l))$/i)?.[1] || '';
      const entryForTitle = value => aliases.get(normalize(value)) || aliases.get(normalize(value).replace(/\s[-–—]\s\d+(?:[.,]\d+)?\s*(?:kg|g|ml|l)$/i, ''));
      const entryForCard = card => card && (data.titles[card.dataset.productId] || entries.find(entry => entry.handle === card.dataset.productHandle));
      const titleWithFormat = (entry, original) => {
        const title = decode(entry.title), format = formatOf(original);
        const compact = value => value.toLowerCase().replace(/\s/g, '');
        const formats = normalize(title).match(/\b\d+(?:[.,]\d+)?\s*(?:kg|g|ml|l)\b/gi) || [];
        return title + (format && !formats.some(value => compact(value) === compact(format)) ? ' - ' + format : '');
      };
      const localizeLink = link => {
        const raw = link.getAttribute('href');
        if (!raw || !data.rootUrl) return;
        try {
          const url = new URL(raw, location.origin);
          if (url.origin !== location.origin || !/^\/products\/[^/]+\/?$/.test(url.pathname)) return;
          const prefix = data.rootUrl.replace(/\/$/, '');
          setAttr(link, 'href', prefix + url.pathname + url.search + url.hash);
        } catch (_) {}
      };
      let root, observer, queued = false;
      const options = {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['class','disabled','data-product-id','data-product-handle','data-variant-id','data-active','data-stock-status']};
      const translate = () => {
        queued = false;
        if (!root?.isConnected) return;
        observer.disconnect();
        setText(root.querySelector('.template-top-data-header-title h2'), data.title);
        const description = root.querySelector('.template-top-data-header-description');
        if (description && Array.isArray(data.contents)) {
          const signature = JSON.stringify(data.contents);
          let contents = description.querySelector('.lbb-kit-contents');
          if (!contents || contents.dataset.contents !== signature) {
            contents = document.createElement('span');
            contents.className = 'lbb-kit-contents';
            contents.dataset.contents = signature;
            contents.setAttribute('role', 'list');
            contents.setAttribute('aria-label', data.contentsLabel);
            data.contents.forEach(label => {
              const pill = document.createElement('span');
              pill.className = 'lbb-kit-contents-pill';
              pill.setAttribute('role', 'listitem');
              pill.textContent = label;
              contents.appendChild(pill);
            });
            description.replaceChildren(contents);
          }
        }
        const sections = Array.from(root.querySelectorAll('.individual-products-section'));
        const stageCount = root.querySelectorAll('.condition-link').length || sections.length;
        const active = root.querySelector('.condition-link.active');
        const activeIndex = Number(active?.dataset.sectionIndex || 0);
        sections.forEach((section, index) => {
          if (Number(section.dataset.sectionIndex ?? index) !== activeIndex) return;
          section.querySelectorAll('.product-card-image img').forEach(image => {
            setAttr(image, 'loading', 'eager');
            setAttr(image, 'decoding', 'async');
          });
        });
        if (data.cresposImage) root.querySelectorAll('.product-card[data-product-id="56403367297289"], .product-card[data-product-handle="masque-pour-cheveux-afro-1kg-crespo-divino-skala"]').forEach(card => {
          const slot = card.querySelector('.product-card-image');
          if (!slot) return;
          let image = slot.querySelector('img');
          if (!image) {
            image = document.createElement('img');
            image.src = data.cresposImage;
            image.alt = card.querySelector('.product-title h4')?.textContent || '';
            slot.appendChild(image);
          }
          if (!image.dataset.lbbImageFallback) {
            image.dataset.lbbImageFallback = 'ready';
            const recover = () => {
              if (image.dataset.lbbImageFallback === 'used') return;
              image.dataset.lbbImageFallback = 'used';
              image.removeAttribute('srcset');
              image.src = data.cresposImage;
            };
            image.addEventListener('error', recover, {once:true});
            if (image.complete && image.naturalWidth === 0) recover();
          }
        });
        root.querySelectorAll('.condition-link').forEach((button, index) => {
          const stage = stages[Number(button.dataset.sectionIndex ?? index)];
          setText(button, labels['step_' + stage]);
          setAttr(button, 'title', labels['step_' + stage]);
        });
        sections.forEach((section, index) => {
          const stage = stages[Number(section.dataset.sectionIndex ?? index)];
          setText(section.querySelector('.section-title'), labels['step_' + stage]);
          setText(section.querySelector('.condition-description'), labels['desc_' + stage]);
        });
        root.querySelectorAll('.bundle-step-description').forEach(node => setText(node, labels['desc_' + stages[activeIndex]]));
        root.querySelectorAll('.bundle-step-condition').forEach(node => setText(node, labels.one_choice));
        root.querySelectorAll('.prev-step').forEach(node => setText(node, labels.previous));
        const cartAction = window.LBBKitEdit?.active ? window.LBBKitEdit.saveLabel : labels.add_to_cart;
        root.querySelectorAll('.next-step').forEach(node => setText(node, stageCount > 0 && activeIndex >= stageCount - 1 ? cartAction : labels.next));
        root.querySelectorAll('.side-cart-checkout-cta button').forEach(node => {setText(node, cartAction); setAttr(node,'title',cartAction);});
        root.querySelectorAll('.add-button:not(:disabled):not(.disabled):not([aria-disabled="true"]), .product-variant-selector-cta button:not(:disabled):not(.disabled):not([aria-disabled="true"])').forEach(node => setText(node,labels.choose));
        root.querySelectorAll('.add-button, .product-variant-selector-cta button').forEach(node => {
          if (node.dataset.stockStatus === 'out-of-stock' || /^(indisponible|rupture de stock|épuisé|sold out|out of stock|unavailable)$/i.test(node.textContent.trim())) setText(node,labels.unavailable);
          else if (/^(already added|déjà ajouté|choix effectué|selection made|selected)$/i.test(node.textContent.trim())) setText(node, data.selectedLabel);
        });
        root.querySelectorAll('.pvsc-header p, .pills-header p').forEach(node => {
          if (/^(format|taille|size|contenance)$/i.test(node.textContent.trim())) setText(node, labels.format);
        });
        root.querySelectorAll('a[href]').forEach(localizeLink);
        root.querySelectorAll('.remove-item-btn').forEach(node => setAttr(node,'aria-label',labels.remove));
        root.querySelectorAll('.close-variant-selector button').forEach(node => setAttr(node,'aria-label',labels.close));
        root.querySelectorAll('.quantity-input').forEach(node => setAttr(node,'aria-label',labels.quantity));
        root.querySelectorAll('.quantity-btn.plus').forEach(node => setAttr(node,'aria-label',labels.increase));
        root.querySelectorAll('.quantity-btn.minus').forEach(node => setAttr(node,'aria-label',labels.decrease));
        root.querySelectorAll('*').forEach(node => {
          if (node.children.length) return;
          const value=node.textContent.trim();
          if (/^(Cart empty|Votre routine commence ici)$/i.test(value)) setText(node,labels.empty);
          if (/^Loading products(?:\.{3}|…)?$/i.test(value)) setText(node,labels.loading);
        });
        const variants = new Map();
        root.querySelectorAll('.product-card[data-product-id]').forEach(card => {
          const entry = entryForCard(card);
          if (!entry) return;
          const heading=card.querySelector('.product-title h4');
          const current=heading?.textContent.trim() || '';
          const title=titleWithFormat(entry,current);
          remember(current,entry);
          remember(title,entry);
          card.querySelectorAll('.quantity-controls[data-variant-id]').forEach(control => variants.set(control.dataset.variantId,entry));
          setText(heading,title);
          setAttr(card.querySelector('.product-card-image img'),'alt',title);
        });
        root.querySelectorAll('.scpt-title h4').forEach(node => {
          const row = node.closest('.sc-product-item');
          const entry = variants.get(row?.dataset.variantId) || entryForTitle(node.textContent);
          if (!entry) return;
          const title = titleWithFormat(entry,node.textContent);
          setText(node,title);
          row?.querySelectorAll('img').forEach(image => setAttr(image,'alt',title));
        });
        root.querySelectorAll('.product-variant-selector-header h3').forEach(node => {
          const activeCard = root.querySelector('.product-card[data-active="true"]');
          const modal = node.closest('.product-variant-selector');
          if (modal?.dataset.lbbProductDetailsHandle === activeCard?.dataset.productHandle && modal?.dataset.lbbProductDetailsTitle) return;
          const entry = entryForCard(activeCard) || entryForTitle(node.textContent);
          if (!entry) return;
          setText(node,decode(entry.title));
          node.closest('.product-variant-selector')?.querySelectorAll('.product-variant-selector-header-image img').forEach(image => setAttr(image,'alt',decode(entry.title)));
        });
        observer.observe(root,options);
      };
      const schedule = () => { if (!queued) { queued=true; requestAnimationFrame(translate); } };
      const start = () => {
        root=document.getElementById('bundlesuiteContainer');
        if (!root) return false;
        observer=new MutationObserver(schedule); translate(); return true;
      };
      if (!start()) {
        const boot = new MutationObserver(() => {if(start())boot.disconnect();});
        boot.observe(document.body,{childList:true,subtree:true});
        setTimeout(()=>boot.disconnect(),30000);
      }
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-kit-mobile"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('lbb-kit-mobile-config');
    if (!config || !document.getElementById('lbb-kit-formula-ui-config') || config.dataset.initialized === 'true') return;
    config.dataset.initialized = 'true';
    const text = config.dataset;
    const mobile = matchMedia('(max-width: 767px)');
    let currentRoot = null;
    let currentCart = null;
    let previousStep = null;
    let expanded = false;
    let scheduled = false;
    let compactHeight = 132;
    let panelHeight = 132;
    const floatingStyles = new Map();
    const writeText = (element, value) => {
      if (element && element.textContent !== value) element.textContent = value;
    };
    const writeClass = (element, name, value) => {
      if (element.classList.contains(name) !== value) element.classList.toggle(name, value);
    };
    const writeAttribute = (element, name, value) => {
      if (element.getAttribute(name) !== value) element.setAttribute(name, value);
    };
    const syncFloatingControls = () => {
      const enabled = mobile.matches && !!currentCart && !!currentRoot?.classList.contains('lbb-kit-mobile-ready');
      const bottom = panelHeight + 12;
      const rules = [
        ['shopify-chat', '.activator-nudge{bottom:' + bottom + 'px!important;width:48px!important;max-width:48px!important;min-width:48px!important;height:48px!important;padding:0!important}.activator-nudge>button.activator[part="activator"]{box-sizing:border-box!important;width:48px!important;height:48px!important;min-width:48px!important;min-height:48px!important;padding:0!important;gap:0!important;display:flex!important;align-items:center!important;justify-content:center!important}.activator-nudge>button.activator[part="activator"]>.activator__label{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}'],
        ['pandectes-cmp', 'button.widget.bottom.left{bottom:' + bottom + 'px!important}']
      ];
      let ready = true;
      for (const [selector, css] of rules) {
        const shadow = document.querySelector(selector)?.shadowRoot;
        let style = floatingStyles.get(selector);
        if (style && (!enabled || style.parentNode !== shadow)) {
          style.remove();
          floatingStyles.delete(selector);
          style = null;
        }
        if (!enabled) continue;
        if (!shadow) {
          ready = false;
          continue;
        }
        if (!style) {
          style = document.createElement('style');
          style.id = 'lbb-kit-mobile-floating';
          shadow.append(style);
          floatingStyles.set(selector, style);
        }
        writeText(style, '@media screen and (max-width:767px){' + css + '}');
      }
      return enabled && ready;
    };
    const updateSpace = () => {
      if (!currentRoot || !currentCart || !mobile.matches) {
        syncFloatingControls();
        return;
      }
      const height = Math.ceil(currentCart.getBoundingClientRect().height);
      if (height > 0) {
        panelHeight = height;
        if (!expanded) compactHeight = height;
      }
      const space = compactHeight + 'px';
      if (height > 0 && currentRoot.style.getPropertyValue('--lbb-kit-mobile-space') !== space) {
        currentRoot.style.setProperty('--lbb-kit-mobile-space', space);
      }
      syncFloatingControls();
    };
    const resize = new ResizeObserver(updateSpace);
    const makeToggle = cart => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'lbb-kit-mobile-toggle';
      const title = document.createElement('span');
      title.className = 'lbb-kit-mobile-toggle-title';
      const label = document.createElement('strong');
      label.textContent = text.summaryLabel;
      const action = document.createElement('span');
      action.className = 'lbb-kit-mobile-toggle-action';
      title.append(label, action);
      const values = document.createElement('span');
      values.className = 'lbb-kit-mobile-toggle-values';
      const selection = document.createElement('span');
      selection.className = 'lbb-kit-mobile-toggle-selection';
      const total = document.createElement('span');
      total.className = 'lbb-kit-mobile-toggle-total';
      const saving = document.createElement('span');
      saving.className = 'lbb-kit-mobile-toggle-saving';
      values.append(selection, total, saving);
      button.append(title, values);
      cart.prepend(button);
      return button;
    };
    const observe = () => {
      const target = currentRoot || document.body;
      observer.observe(target, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['class', 'data-section-index']
      });
    };
    const render = () => {
      observer.disconnect();
      const root = document.getElementById('bundlesuiteContainer');
      const cart = root?.querySelector('.side-cart-container');
      if (!root || !cart || !root.classList.contains('lbb-kit-formula-ui')) {
        writeClass(document.documentElement, 'lbb-kit-mobile-active', false);
        currentCart = null;
        currentRoot = root;
        syncFloatingControls();
        observe();
        return;
      }
      if (currentRoot !== root || currentCart !== cart) {
        const sameRoot = currentRoot === root;
        resize.disconnect();
        currentRoot = root;
        currentCart = cart;
        if (!sameRoot) {
          previousStep = null;
          expanded = false;
        }
        resize.observe(cart);
      }
      const step = root.querySelector('.condition-link.active[data-section-index]')?.dataset.sectionIndex ?? null;
      if (previousStep !== null && step !== previousStep) expanded = false;
      if (!mobile.matches) expanded = false;
      previousStep = step;
      writeClass(document.documentElement, 'lbb-kit-mobile-active', mobile.matches);
      writeClass(root, 'lbb-kit-mobile-ready', mobile.matches);
      writeClass(cart, 'lbb-kit-mobile-cart', mobile.matches);
      writeClass(cart, 'lbb-kit-mobile-open', mobile.matches && expanded);
      const next = cart.querySelector('.bundle-step-buttons .next-step');
      const nextVisible = !!next && next.getClientRects().length > 0 && getComputedStyle(next).visibility !== 'hidden';
      writeClass(cart, 'lbb-kit-mobile-step-action', mobile.matches && nextVisible);
      let toggle = cart.querySelector(':scope > .lbb-kit-mobile-toggle');
      if (!toggle) toggle = makeToggle(cart);
      writeAttribute(toggle, 'aria-expanded', expanded ? 'true' : 'false');
      const controlled = [];
      for (const [selector, suffix] of [
        ['.side-cart-header', 'header'],
        ['.side-cart-product-container', 'products'],
        ['.lbb-kit-savings', 'savings'],
        ['.side-cart-checkout-wrapper', 'totals']
      ]) {
        const node = cart.querySelector(selector);
        if (!node) continue;
        if (!node.id) node.id = 'lbb-kit-mobile-' + suffix;
        controlled.push(node.id);
      }
      writeAttribute(toggle, 'aria-controls', controlled.join(' '));
      writeText(toggle.querySelector('.lbb-kit-mobile-toggle-action'), expanded ? text.hideDetails : text.showDetails);
      const count = cart.querySelector('.added-products-count')?.textContent.trim() || '0';
      writeText(toggle.querySelector('.lbb-kit-mobile-toggle-selection'), count + ' ' + text.selectionLabel);
      const total = cart.querySelector('.side-cart-checkout-wrapper .total-value')?.textContent.trim() || '';
      writeText(toggle.querySelector('.lbb-kit-mobile-toggle-total'), total && count !== '0' ? text.totalLabel + ' ' + total : '');
      const saving = cart.querySelector('.lbb-kit-savings.is-positive [data-savings-state]')?.textContent.trim() || '';
      writeText(toggle.querySelector('.lbb-kit-mobile-toggle-saving'), saving);
      if (!mobile.matches) {
        if (root.style.getPropertyValue('--lbb-kit-mobile-space')) root.style.removeProperty('--lbb-kit-mobile-space');
      }
      observe();
      updateSpace();
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        render();
      });
    };
    const observer = new MutationObserver(schedule);
    mobile.addEventListener('change', schedule);
    document.addEventListener('click', event => {
      if (!mobile.matches) return;
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const toggle = target?.closest('.lbb-kit-mobile-toggle');
      if (!toggle) return;
      const root = document.getElementById('bundlesuiteContainer');
      const cart = root?.querySelector('.side-cart-container');
      if (!root || !cart || !cart.contains(toggle)) return;
      if (root !== currentRoot || cart !== currentCart) render();
      if (!currentCart?.contains(toggle)) return;
      event.preventDefault();
      event.stopPropagation();
      expanded = !expanded;
      render();
      if (!expanded && currentCart) currentCart.scrollTop = 0;
    }, true);
    new MutationObserver(records => {
      const appAdded = records.some(record => Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (node.matches('shopify-chat, pandectes-cmp') || node.querySelector('shopify-chat, pandectes-cmp'))
      ));
      if (appAdded) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    let floatingAttempts = 0;
    const waitForFloatingControls = () => {
      if (!mobile.matches) return;
      floatingAttempts += 1;
      if (!syncFloatingControls() && floatingAttempts < 15) setTimeout(waitForFloatingControls, 1000);
    };
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !mobile.matches || !expanded) return;
      const focused = document.activeElement;
      const returnFocus = currentCart?.contains(focused);
      expanded = false;
      render();
      if (returnFocus) currentCart.querySelector('.lbb-kit-mobile-toggle')?.focus();
    });
    render();
    waitForFloatingControls();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-kit-product-details-i18n"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('lbb-kit-product-details-config');
    if (!config || config.dataset.initialized || typeof window.fetch !== 'function') return;
    config.dataset.initialized = 'true';
    const data = JSON.parse(config.textContent);
    const entities = { '&amp;': '&', '&quot;': '"', '&apos;': "'", '&#39;': "'", '&#x27;': "'", '&lt;': '<', '&gt;': '>' };
    const labels = Object.fromEntries(Object.entries(data.labels || {}).map(([key,value]) => [key, String(value).replace(/&(?:amp|quot|apos|#39|#x27|lt|gt);/gi, entity => entities[entity.toLowerCase()])]));
    const prefix = String(data.rootUrl || '/').replace(/\/$/, '');
    const cache = new Map();
    const renderedDescriptions = new WeakMap();
    const setText = (node, value) => { if (node && typeof value === 'string' && node.textContent !== value) node.textContent = value; };
    const setAttr = (node, key, value) => { if (node && node.getAttribute(key) !== value) node.setAttribute(key, value); };
    const setNativeLabel = (node, value) => {
      if (!node || !value) return;
      const leaves = Array.from(node.childNodes || []).filter(child => child.nodeType === 3 && child.textContent.trim());
      if (leaves.length === 1) setText(leaves[0],value);
      else if (!node.children.length) setText(node,value);
    };
    const localizeNativeControls = () => {
      const root = document.getElementById('bundlesuiteContainer');
      if (!root) return;
      for (const [selector,original,key] of [
        ['.bundle-step-button.prev-step',/^Previous$/i,'previous'],
        ['.bundle-step-button.next-step',/^Next$/i,'next'],
        ['.side-cart-checkout-cta button',/^Checkout$/i,'checkout']
      ]) {
        root.querySelectorAll(selector).forEach(button => {
          if (original.test(button.textContent.trim())) setNativeLabel(button,labels[key]);
          if (labels[key] && original.test(button.getAttribute('aria-label') || '')) setAttr(button,'aria-label',labels[key]);
          if (labels[key] && original.test(button.getAttribute('title') || '')) setAttr(button,'title',labels[key]);
        });
      }
      root.querySelectorAll('.side-cart-checkout-cta button').forEach(button => {
        if (labels.requirements && /^Tier requirements not yet met$/i.test(button.getAttribute('title') || '')) setAttr(button,'title',labels.requirements);
      });
      document.body.querySelectorAll('[aria-label]').forEach(node => {
        const label = (node.getAttribute('aria-label') || '').trim();
        let translated;
        if (/^Previous slide$/i.test(label)) translated = labels.previousSlide;
        else if (/^Next slide$/i.test(label)) translated = labels.nextSlide;
        else if (/^Go to first slide$/i.test(label)) translated = labels.firstSlide;
        else if (/^Go to last slide$/i.test(label)) translated = labels.lastSlide;
        else {
          const slide = label.match(/^Go to slide (\d+)$/i);
          const position = label.match(/^(\d+) of (\d+)$/i);
          if (slide && labels.goToSlide) translated = labels.goToSlide.replace('__NUMBER__',slide[1]);
          else if (position && labels.slidePosition) translated = labels.slidePosition.replace('__CURRENT__',position[1]).replace('__TOTAL__',position[2]);
        }
        if (translated) setAttr(node,'aria-label',translated);
      });
      root.querySelectorAll('[aria-label]').forEach(node => {
        if (labels.viewProduct && /^View product$/i.test(node.getAttribute('aria-label') || '')) setAttr(node,'aria-label',labels.viewProduct);
      });
      document.body.querySelectorAll('.bundle-toast.success .bundle-toast-message').forEach(node => {
        if (labels.addedToCart && /^(?:(?:product|item) )?added to cart[.!]?$/i.test(node.textContent.trim())) setNativeLabel(node,labels.addedToCart);
      });
    };
    const cleanId = value => String(value || '').replace(/^gid:\/\/shopify\/(?:Product|ProductVariant)\//, '');
    const productPath = value => {
      try {
        const url = new URL(value, location.origin);
        if (url.origin !== location.origin) return null;
        const match = url.pathname.match(/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/products\/([a-z0-9][a-z0-9-]*)\/?$/i);
        return match ? {handle:match[1],url} : null;
      } catch (_) { return null; }
    };
    const current = () => {
      const root = document.getElementById('bundlesuiteContainer');
      const modal = root?.querySelector('.product-variant-selector');
      if (!modal || modal.hidden || modal.classList.contains('closed') || modal.getAttribute('aria-hidden') === 'true') return null;
      const cards = root.querySelectorAll('.product-card[data-active="true"]');
      if (cards.length !== 1) return null;
      const card = cards[0];
      let handle = card.dataset.productHandle;
      if (!/^[a-z0-9][a-z0-9-]*$/i.test(handle || '')) {
        handle = Array.from(card.querySelectorAll('a[href]')).map(link => productPath(link.getAttribute('href'))?.handle).find(Boolean);
      }
      return handle ? {root,modal,card,handle,id:cleanId(card.dataset.productId)} : null;
    };
    const matches = (left, right) => left && right && left.modal === right.modal && left.card === right.card && left.handle === right.handle && left.id === right.id;
    const fetchProduct = (handle, routePrefix) => {
      const url = routePrefix + '/products/' + encodeURIComponent(handle) + '.js';
      if (!cache.has(url)) {
        const record = {value:null,settled:false};
        record.promise = window.fetch(url,{credentials:'same-origin',headers:{Accept:'application/json'}})
          .then(response => { if (!response.ok) throw new Error('product-details'); return response.json(); })
          .then(product => {
            if (!product || product.handle !== handle || typeof product.title !== 'string' || !Array.isArray(product.variants)) throw new Error('product-identity');
            record.value = product;
            return product;
          }).catch(() => null).then(product => { record.settled = true; return product; });
        cache.set(url,record);
      }
      return cache.get(url);
    };
    const optionValues = variant => Array.isArray(variant.options) ? variant.options : [variant.option1,variant.option2,variant.option3].filter(value => value != null);
    const translatedOption = (product, source, index, value) => {
      if (!source || !Array.isArray(source.variants)) return null;
      const sourceVariants = source.variants.filter(variant => optionValues(variant)[index] === value);
      const translations = new Set(sourceVariants.map(variant => product.variants.find(localized => String(localized.id) === String(variant.id)))
        .filter(Boolean).map(variant => optionValues(variant)[index]).filter(value => typeof value === 'string'));
      return translations.size === 1 ? [...translations][0] : null;
    };
    const render = (context, product, source) => {
      if (!matches(context,current())) return;
      if (context.id && String(product.id) !== context.id && !product.variants.some(variant => String(variant.id) === context.id)) {
        setAttr(context.modal,'data-lbb-product-details-status','unavailable');
        return;
      }
      const {modal,handle} = context;
      setAttr(modal,'data-lbb-product-details-handle',handle);
      setAttr(modal,'data-lbb-product-details-title',product.title);
      setAttr(modal,'data-lbb-product-details-status',prefix && source && product.description === source.description ? 'source-identical' : 'localized');
      setText(modal.querySelector('.product-variant-selector-header h3'),product.title);
      modal.querySelectorAll('.product-variant-selector-header-image img').forEach(image => setAttr(image,'alt',product.title));
      const description = modal.querySelector('.product-variant-selector-header-description p');
      if (description && typeof product.description === 'string') {
        const previous = renderedDescriptions.get(description);
        if (previous?.handle !== handle || previous.source !== product.description || previous.html !== description.innerHTML) {
          description.innerHTML = product.description;
          renderedDescriptions.set(description,{handle,source:product.description,html:description.innerHTML});
        }
      }
      modal.querySelectorAll('.product-variant-selector-section').forEach(section => {
        const values = section.querySelector('.pvsc-items-container[data-option-position]');
        const index = Number(values?.dataset.optionPosition) - 1;
        const option = product.options?.find((option,offset) => Number(option.position || offset + 1) === index + 1);
        if (!values || !Number.isInteger(index) || index < 0 || !option || typeof option.name !== 'string') return;
        setText(section.querySelector('.pvsc-header p'),/^(format|taille|size|contenance)$/i.test(option.name) && data.format ? data.format : option.name);
        values.querySelectorAll('.pvsc-item[data-variant-value]').forEach(item => {
          const translated = translatedOption(product,source,index,item.dataset.variantValue);
          if (!translated) return;
          setText(item.querySelector('.value-container p'),translated);
          item.querySelectorAll('img').forEach(image => setAttr(image,'alt',translated));
        });
      });
      modal.querySelectorAll('a[href]').forEach(link => {
        const target = productPath(link.getAttribute('href'));
        if (!target) return;
        setAttr(link,'href',prefix+'/products/'+target.handle+target.url.search+target.url.hash);
      });
    };
    let queued = false;
    let pending = null;
    const sync = () => {
      queued = false;
      localizeNativeControls();
      const context = current();
      if (!context) { pending = null; return; }
      context.modal.querySelectorAll('a[href]').forEach(link => {
        const target = productPath(link.getAttribute('href'));
        if (target) setAttr(link,'href',prefix+'/products/'+target.handle+target.url.search+target.url.hash);
      });
      if (context.modal.dataset.lbbProductDetailsHandle && context.modal.dataset.lbbProductDetailsHandle !== context.handle) {
        context.modal.removeAttribute('data-lbb-product-details-handle');
        context.modal.removeAttribute('data-lbb-product-details-title');
        context.modal.removeAttribute('data-lbb-product-details-status');
      }
      const localized = fetchProduct(context.handle,prefix);
      const source = prefix ? fetchProduct(context.handle,'') : localized;
      if (localized.value && source.settled) { render(context,localized.value,source.value); return; }
      if (matches(context,pending)) return;
      pending = context;
      Promise.all([localized.promise,source.promise]).then(([product,original]) => {
        if (pending !== context || !matches(context,current())) return;
        if (!product) { setAttr(context.modal,'data-lbb-product-details-status','unavailable'); return; }
        render(context,product,original);
      });
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(sync); } };
    new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class','hidden','aria-hidden','aria-label','title','data-active','data-product-id','data-product-handle']});
    sync();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-kit-savings"] && !Shopify.designMode) return;
  try {
    (() => {
    const isKnownComplementCard = (card, variantId, variants, handles) => {
      const expectedProductId = variants[variantId];
      if (!card || !expectedProductId) return false;
      const actualId = card.dataset.productId;
      const handle = card.dataset.productHandle;
      const expectedHandle = handles[expectedProductId];
      if (actualId === expectedProductId) return !handle || handle === expectedHandle;
      return actualId === variantId && Boolean(expectedHandle) && handle === expectedHandle;
    };
    const parseEurMoney = value => {
      if (typeof value !== 'string') return null;
      const compact = value.trim().replace(/[\s\u00a0\u202f]/g, '');
      if (!/^(?:€|EUR)?\d[\d.,]*(?:€|EUR)?$/i.test(compact)) return null;
      const currencies = compact.match(/€|EUR/gi) || [];
      if (currencies.length !== 1) return null;
      const amount = compact.replace(/€|EUR/gi, '');
      let normalized;
      if (/^\d+(?:[.,]\d{2})?$/.test(amount)) normalized = amount.replace(',', '.');
      else if (/^\d{1,3}(?:\.\d{3})+,\d{2}$/.test(amount)) normalized = amount.replace(/\./g, '').replace(',', '.');
      else if (/^\d{1,3}(?:,\d{3})+\.\d{2}$/.test(amount)) normalized = amount.replace(/,/g, '');
      else return null;
      const cents = Math.round(Number(normalized) * 100);
      return Number.isSafeInteger(cents) && cents >= 0 ? cents : null;
    };
    const validateProductPrice = (payload, expected) => {
      if (!payload || typeof payload !== 'object') return null;
      if (String(payload.id) !== expected.productId) return null;
      if (payload.handle !== expected.handle) return null;
      if (!Array.isArray(payload.variants)) return null;
      const variants = payload.variants.filter(variant => String(variant?.id) === expected.variantId);
      if (variants.length !== 1) return null;
      if (variants[0].available !== true) return null;
      if (!Number.isSafeInteger(variants[0].price) || variants[0].price <= 0) return null;
      return variants[0].price;
    };
    const createReferencePriceSource = ({ origin, rootUrl, expectedCurrency, fetcher, catalog, handles }) => {
      const pageCache = new Map();
      const endpoint = suffix => {
        if (typeof rootUrl !== 'string' || !rootUrl.startsWith('/') || rootUrl.startsWith('//') || /[?#]/.test(rootUrl)) throw new Error('invalid_locale_root');
        const url = new URL(rootUrl.replace(/\/?$/, '/') + suffix, origin);
        if (url.origin !== origin) throw new Error('cross_origin_reference');
        return url.href;
      };
      const readJson = async url => {
        const response = await fetcher(url, {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          redirect: 'error',
          headers: { Accept: 'application/json' }
        });
        const contentType = response.headers?.get('content-type') || '';
        const mediaType = contentType.split(';')[0].trim().toLowerCase();
        if (!response.ok) throw new Error('http_error');
        if (!['application/json', 'application/javascript', 'text/javascript'].includes(mediaType)) throw new Error('non_json');
        return response.json();
      };
      const getVariantPrice = async variantId => {
        if (expectedCurrency !== 'EUR') return null;
        const productId = catalog[variantId];
        const handle = handles[productId];
        if (!productId || typeof handle !== 'string' || !/^[a-z0-9][a-z0-9-]*$/.test(handle)) return null;
        try {
          if (!pageCache.has(handle)) pageCache.set(handle, readJson(endpoint('products/' + encodeURIComponent(handle) + '.js')));
          const payload = await pageCache.get(handle);
          return validateProductPrice(payload, { variantId, productId, handle });
        } catch (_) {
          return null;
        }
      };
      return { getVariantPrice };
    };
    const selectionSignature = snapshot => JSON.stringify({
      parentId: snapshot.parentId,
      currency: snapshot.currency,
      nativeSubtotal: snapshot.nativeSubtotal,
      nativeDiscount: snapshot.nativeDiscount,
      total: snapshot.total,
      rows: snapshot.rows.map(row => [row.variantId, row.productId, row.quantity, row.nativePrice, row.knownVariant, row.isDuo, row.sectionIndex]).sort((left, right) => left[0].localeCompare(right[0]))
    });
    const formulaPolicies = {
      '15686025478409': { choices: 1, percent: 0 },
      '15686025806089': { choices: 2, percent: 2 },
      '15686025871625': { choices: 3, percent: 3 },
      '15686026985737': { choices: 4, percent: 4 }
    };
    const adjustedDuoVariants = new Set(['57357251281161', '57357251707145', '57357251805449', '57357252329737']);
    const calculateComparison = ({ parentId, currency, rows, nativeSubtotal, nativeDiscount, total, references }) => {
      const policy = formulaPolicies[parentId];
      const unavailable = (reason, row = {}) => ({ state: 'unavailable', reason, variantId: row.variantId, sectionIndex: row.sectionIndex });
      if (!policy) return unavailable('unknown_parent');
      if (currency !== 'EUR') return unavailable('unsupported_currency');
      if (!rows.length) return { state: 'empty' };
      if (rows.length < policy.choices) return { state: 'incomplete' };
      if (rows.length !== policy.choices) return unavailable('row_count_mismatch');
      if (!Number.isSafeInteger(total) || total <= 0) return unavailable('invalid_native_total');
      const seen = new Set();
      const sections = new Set();
      let reference = 0;
      let publicSum = 0;
      let nativeSum = 0;
      let duoCount = 0;
      let duoAdjustment = 0;
      for (const row of rows) {
        if (!row.variantId || seen.has(row.variantId) || row.quantity !== 1 || !Number.isSafeInteger(row.nativePrice) || row.nativePrice <= 0) return unavailable('invalid_native_row', row);
        if (!Number.isInteger(row.sectionIndex) || row.sectionIndex < 0 || row.sectionIndex >= policy.choices || sections.has(row.sectionIndex)) return unavailable('invalid_section', row);
        if (!Number.isSafeInteger(row.publicPrice) || row.publicPrice <= 0) return unavailable('reference_price_missing', row);
        seen.add(row.variantId);
        sections.add(row.sectionIndex);
        publicSum += row.publicPrice;
        nativeSum += row.nativePrice;
        const duo = references[row.variantId];
        if (duo) {
          if (row.sectionIndex !== 0 || row.productId !== duo.productId || !Number.isSafeInteger(duo.shampooPrice) || duo.shampooPrice <= 0 || !Number.isSafeInteger(duo.conditionerPrice) || duo.conditionerPrice <= 0) return unavailable('duo_reference_invalid', row);
          reference += duo.shampooPrice + duo.conditionerPrice;
          duoCount += 1;
          if (policy.choices === 1 && adjustedDuoVariants.has(row.variantId)) duoAdjustment = 100;
        } else {
          if (row.isDuo || row.sectionIndex === 0 || !row.knownVariant) return unavailable('complement_identity_invalid', row);
          reference += row.publicPrice;
        }
        const allowedAdjustment = policy.choices === 1 && duo ? duoAdjustment : 0;
        if (row.nativePrice !== row.publicPrice - allowedAdjustment) return unavailable('native_public_price_variance', row);
      }
      if (![reference, publicSum, nativeSum].every(Number.isSafeInteger)) return unavailable('unsafe_price_sum');
      const expectedSubtotal = publicSum - duoAdjustment;
      const expectedTotal = expectedSubtotal - Math.floor(expectedSubtotal * policy.percent / 100);
      if (duoCount !== 1) return unavailable('duo_count_mismatch');
      if (total !== expectedTotal || nativeSum !== publicSum - duoAdjustment) return unavailable('native_total_variance');
      if (policy.percent > 0 && (nativeSubtotal !== nativeSum || nativeDiscount !== nativeSubtotal - total)) return unavailable('native_discount_variance');
      if (policy.percent === 0 && ((nativeSubtotal !== undefined && nativeSubtotal !== nativeSum) || (nativeDiscount !== undefined && nativeDiscount !== 0))) return unavailable('native_duo_subtotal_variance');
      const saving = reference - total;
      return { state: saving > 0 ? 'positive' : saving === 0 ? 'equal' : 'higher', reference, total, saving, nativeDiscount: publicSum - total };
    };
    const config = document.getElementById('lbb-kit-savings-config');
    if (!config || config.dataset.initialized === 'true') return;
    config.dataset.initialized = 'true';
    const text = config.dataset;
    let references = {};
    try {
      references = JSON.parse(document.getElementById('lbb-kit-savings-references').textContent);
    } catch (_) {}
    const duoProductIds = new Set(Object.values(references).map(duo => duo.productId));
    const complementVariants = {
      '43989447409929': '8096905986313',
      '56378008437001': '15406293516553',
      '56388292641033': '15409984504073',
      '56403367297289': '15413407056137',
      '57175839867145': '15413445329161',
      '56403674988809': '15413445329161',
      '57175830331657': '15413508866313',
      '56404346929417': '15413508866313',
      '57180580708617': '15618228453641',
      '57180580741385': '15618228486409',
      '44042099425545': '8112591733001',
      '44042130063625': '8112600842505',
      '44042149724425': '8112609296649',
      '56377335546121': '15406046642441',
      '56392896184585': '15412273414409',
      '56403268993289': '15413370224905',
      '56804217684233': '15488852689161',
      '57339197587721': '15677622845705',
      '57194115432713': '15624220901641',
      '57194106355977': '15624218706185'
    };
    const complementHandles = {
      '8096905986313': 'masque-inceller-250-ml-lana-brasiles-reconstructeur',
      '15406293516553': 'masque-skala-bomba-de-vitaminas-1kg-soin-pour-cheveux-secs',
      '15409984504073': 'skala-creme-traitement-2-en-1-1kg-mais-liso',
      '15413407056137': 'masque-pour-cheveux-afro-1kg-crespo-divino-skala',
      '15413445329161': 'masque-hydratant-tropical-coconut-lana-brasiles',
      '15413508866313': 'masque-reparateur-forest-tanino-lana-brasiles',
      '15618228453641': 'masque-blond-reverse-200g-lana-brasiles',
      '15618228486409': 'masque-glossy-reverse-200g-lana-brasiles',
      '8112591733001': 'huile-de-finition-inceller-lana-brasiles',
      '8112600842505': 'spray-thermo-protecteur-260-ml-lana-brasiles',
      '8112609296649': 'leave-in-inceller-200-ml-lana-brasiles',
      '15406046642441': 'creme-coiffante-sans-rincage-skala-bomba-vitaminas',
      '15412273414409': 'skala-leave-in-boucles-3-en-1-avec-protecteur-thermique',
      '15413370224905': 'skala-crespo-divino-3-en-1-leave-in-vegan',
      '15488852689161': 'brume-capillaire-rayhanete-de-lana-brasiles',
      '15677622845705': 'body-splash-nuvem-200-ml',
      '15624220901641': 'body-splash-cuide-se-bem-deleite-200-ml-o-boticario',
      '15624218706185': 'body-splash-nativa-spa-ameixa-negra-200-ml-o-boticario'
    };
    const duoHandles = {
      '8145878778121': 'kit-inceller-shampoing-apres-shampoing',
      '8146348278025': 'kit-tropical-coconut-shampooing-apres-shampoing',
      '8146694537481': 'kit-forest-tanino-shampooing-apres-shampooing-lana-brasiles',
      '15428664852745': 'skala-mais-liso-shampoing-apres-shampoing-anti-frizz',
      '15685082939657': 'kit-duo-crespo-divino-shampoing-apres-shampoing-2-325-ml',
      '15685082972425': 'kit-duo-bomba-vitaminas-shampoing-apres-shampoing-2-325-ml',
      '15685083070729': 'kit-duo-match-science-pre-e-pos-quimica-shampoing-apres-shampoing-300-ml-280-ml',
      '15685083103497': 'kit-duo-satine-lily-shampoing-apres-shampoing-2-250-ml'
    };
    const publicPrices = createReferencePriceSource({
      origin: window.location.origin,
      rootUrl: text.rootUrl,
      expectedCurrency: text.currency,
      fetcher: window.fetch.bind(window),
      catalog: { ...complementVariants, ...Object.fromEntries(Object.entries(references).map(([id, duo]) => [id, duo.productId])) },
      handles: { ...complementHandles, ...duoHandles }
    });
    let pending = false;
    let requestedSignature = '';
    let resolvedSignature = '';
    let resolvedResult = null;
    let formatter;
    try {
      formatter = new Intl.NumberFormat(text.locale || 'fr', { style: 'currency', currency: 'EUR' });
    } catch (_) {
      formatter = new Intl.NumberFormat('fr', { style: 'currency', currency: 'EUR' });
    }
    const money = cents => formatter.format(cents / 100);
    const setText = (element, value) => {
      if (element.textContent !== value) element.textContent = value;
    };
    const setHidden = (element, hidden) => {
      if (element.hidden !== hidden) element.hidden = hidden;
    };
    const buildPanel = () => {
      const panel = document.createElement('section');
      panel.className = 'lbb-kit-savings';
      panel.setAttribute('aria-labelledby', 'lbb-kit-savings-title');
      const title = document.createElement('h4');
      title.id = 'lbb-kit-savings-title';
      title.textContent = text.title;
      const values = document.createElement('dl');
      values.dataset.savingsValues = '';
      for (const key of ['reference', 'total']) {
        const line = document.createElement('div');
        const label = document.createElement('dt');
        label.textContent = text[key];
        const value = document.createElement('dd');
        value.dataset.savingsValue = key;
        line.append(label, value);
        values.append(line);
      }
      const state = document.createElement('p');
      state.dataset.savingsState = '';
      state.setAttribute('role', 'status');
      state.setAttribute('aria-live', 'polite');
      state.setAttribute('aria-atomic', 'true');
      const basis = document.createElement('p');
      basis.dataset.savingsBasis = '';
      basis.textContent = text.basis;
      const explanation = document.createElement('p');
      explanation.dataset.savingsExplanation = '';
      panel.append(title, values, state, basis, explanation);
      return panel;
    };
    const readSnapshot = root => {
      const cards = Array.from(root.querySelectorAll('.product-card[data-product-id]'));
      const rows = Array.from(root.querySelectorAll('.sc-product-item[data-variant-id]'), row => {
        const variantId = row.dataset.variantId;
        const matches = cards.filter(card => Array.from(card.querySelectorAll('.quantity-controls[data-variant-id]')).some(control => control.dataset.variantId === variantId));
        const card = matches.length === 1 ? matches[0] : null;
        const productId = card ? card.dataset.productId : '';
        const section = card && card.closest('.individual-products-section');
        const quantityText = row.querySelector('.scpt-price-quantity')?.textContent.trim() || '';
        return {
          variantId,
          productId,
          quantity: /^\d+$/.test(quantityText) ? Number(quantityText) : null,
          nativePrice: parseEurMoney(row.querySelector('.scpt-price-value')?.textContent),
          sectionIndex: section && /^\d+$/.test(section.dataset.sectionIndex) ? Number(section.dataset.sectionIndex) : null,
          knownVariant: isKnownComplementCard(card, variantId, complementVariants, complementHandles),
          isDuo: duoProductIds.has(productId) || section?.dataset.sectionIndex === '0'
        };
      });
      const readNativeValue = selector => {
        const nodes = Array.from(root.querySelectorAll(selector));
        if (!nodes.length) return undefined;
        const values = nodes.map(node => parseEurMoney(node.textContent));
        return values.every(value => value === values[0]) ? values[0] : null;
      };
      return {
        parentId: text.productId,
        currency: text.currency,
        rows,
        nativeSubtotal: readNativeValue('.side-cart-checkout-wrapper .subtotal-value'),
        nativeDiscount: readNativeValue('.side-cart-checkout-wrapper .discount-value'),
        total: readNativeValue('.side-cart-checkout-wrapper .total-value')
      };
    };
    const readComparison = root => {
      const snapshot = readSnapshot(root);
      if (!snapshot.rows.length) {
        requestedSignature = '';
        return { state: 'empty' };
      }
      const policy = formulaPolicies[snapshot.parentId];
      if (!policy || snapshot.currency !== 'EUR') {
        requestedSignature = '';
        return { state: 'unavailable', reason: !policy ? 'unknown_parent' : 'unsupported_currency' };
      }
      if (snapshot.rows.length < policy.choices) {
        requestedSignature = '';
        return { state: 'incomplete' };
      }
      if (snapshot.rows.length !== policy.choices) {
        requestedSignature = '';
        return { state: 'unavailable', reason: 'row_count_mismatch' };
      }
      const signature = selectionSignature(snapshot);
      if (resolvedSignature === signature) return resolvedResult;
      if (requestedSignature !== signature) {
        requestedSignature = signature;
        Promise.all(snapshot.rows.map(async row => ({ ...row, publicPrice: await publicPrices.getVariantPrice(row.variantId) }))).then(rows => {
          if (requestedSignature !== signature) return;
          const currentRoot = document.getElementById('bundlesuiteContainer');
          if (!currentRoot || selectionSignature(readSnapshot(currentRoot)) !== signature) {
            requestedSignature = '';
            return;
          }
          resolvedSignature = signature;
          resolvedResult = calculateComparison({ ...snapshot, rows, references });
          observer.disconnect();
          render();
          observe();
        });
      }
      return { state: 'loading' };
    };
    const render = () => {
      const root = document.getElementById('bundlesuiteContainer');
      const checkout = root && root.querySelector('.side-cart-checkout-wrapper');
      if (!checkout) return;
      let panel = root.querySelector('.lbb-kit-savings');
      if (!panel) {
        panel = buildPanel();
        checkout.before(panel);
      }
      const result = readComparison(root);
      const hasValues = ['positive', 'equal', 'higher'].includes(result.state);
      setHidden(panel.querySelector('[data-savings-values]'), !hasValues);
      setHidden(panel.querySelector('[data-savings-basis]'), !hasValues);
      setHidden(panel.querySelector('[data-savings-explanation]'), result.state !== 'positive');
      const positive = result.state === 'positive';
      if (panel.classList.contains('is-positive') !== positive) panel.classList.toggle('is-positive', positive);
      if (hasValues) {
        setText(panel.querySelector('[data-savings-value="reference"]'), money(result.reference));
        setText(panel.querySelector('[data-savings-value="total"]'), money(result.total));
        setText(panel.querySelector('[data-savings-explanation]'), result.nativeDiscount > 0 ? text.nativeDiscount : text.duo);
      }
      setText(panel.querySelector('[data-savings-state]'), positive ? text.saving + ' ' + money(result.saving) : text[result.state]);
    };
    const observer = new MutationObserver(() => {
      if (pending) return;
      pending = true;
      queueMicrotask(() => {
        pending = false;
        observer.disconnect();
        render();
        observe();
      });
    });
    const observe = () => observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-variant-id', 'data-product-id', 'data-product-handle', 'data-section-index']
    });
    render();
    observe();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-legacy-kit-pricing"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('lbb-legacy-kit-pricing');
  if (!config) return;
  const copy = config.dataset;
  const euroCents = value => {
    const compact = String(value || '').replace(/\s/g, '').replace(/−/g, '-');
    if (!/^(?:[+-]?€[+-]?\d+(?:[,.]\d{2})?|[+-]?\d+(?:[,.]\d{2})?€)$/.test(compact)) return NaN;
    const number = compact.replace('€', '').replace(',', '.');
    if (!/^[+-]?\d+(?:\.\d{2})?$/.test(number)) return NaN;
    const cents = Math.round(Number(number) * 100);
    return Number.isSafeInteger(cents) ? cents : NaN;
  };
  const adjustmentKind = value => {
    const amount = String(value || '').trim();
    if (!/\d/.test(amount)) return 'adjustment';
    if (/[-−]/.test(amount) && /[1-9]/.test(amount)) return 'benefit';
    return /[1-9]/.test(amount) ? 'surcharge' : 'adjustment';
  };
  const nativeSaving = (currency, complete, subtotal, total, adjustment) => {
    if (currency !== 'EUR' || !complete) return null;
    const values = [subtotal, total, adjustment].map(euroCents);
    if (!values.every(Number.isSafeInteger)) return null;
    const [before, actual, extra] = values;
    if (before <= 0 || actual <= 0 || extra >= 0 || before + extra !== actual) return null;
    return -extra;
  };
  const text = (element, value) => { if (element && element.textContent !== value) element.textContent = value; };
  const init = () => {
    const root = document.querySelector('#bundlesuiteContainer');
    if (!root) return false;
    if (root.dataset.lbbLegacyPricingReady) return true;
    root.dataset.lbbLegacyPricingReady = 'true';
    let queued = false;
    const sync = () => {
      queued = false;
      const recap = root.querySelector('.side-cart-checkout-wrapper');
      if (!recap) return;
      recap.querySelectorAll('.subtotal-text').forEach(label => text(label, copy.subtotal));
      recap.querySelectorAll('.additional-text').forEach(label => {
        const amount = label.closest('.side-cart-checkout-item')?.querySelector('.additional-value')?.textContent;
        text(label, copy[adjustmentKind(amount)]);
      });
      const saving = recap.querySelector('.lbb-integral-saving');
      if (!saving) return;
      const amount = nativeSaving(copy.currency, root.hasAttribute('data-integral-complete'), recap.querySelector('.subtotal-value')?.textContent, recap.querySelector('.total-value')?.textContent, recap.querySelector('.additional-value')?.textContent);
      if (amount !== null) {
        const formatted = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: 'EUR' }).format(amount / 100);
        text(saving.querySelector('strong'), copy.savings.replace('__AMOUNT__', formatted));
        text(saving.querySelector('span'), copy.savingDetails);
      }
      if (saving.hidden !== (amount === null)) saving.hidden = amount === null;
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(sync); } };
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-integral-complete'] });
    sync();
    return true;
  };
  if (!init()) {
    const wait = new MutationObserver(() => { if (init()) wait.disconnect(); });
    wait.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-lissage-cart-components"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('lbb-lissage-cart')) return;
  class LBBLissageCart extends HTMLElement {
    connectedCallback() { requestAnimationFrame(() => this.prepare()); }
    prepare() {
      if (this.dataset.ready === 'true') return;
      const status=this.querySelector('[data-component-status]');
      try {
        const parent=this.dataset.parentId;
        const policy={
          '15689118744841':{minimum:2,lissages:['57175771054345','57175796973833','57175820697865']},
          '15689165406473':{minimum:2,lissages:['44451037544713','44450767503625','44451046883593']},
          '15686744375561':{minimum:1,lissages:[]},
          '15686016532745':{minimum:2,lissages:[]},
          '15705118310665':{minimum:2,lissages:["57445681496329","57445773508873"],single:false},
          '15705139052809':{minimum:2,lissages:["48749677871369","57445773476105"],single:false}
        }[parent];
        const lissages=policy?.lissages||[];
        const singleMode=this.dataset.lissageMode==='single';
        if(singleMode&&(!lissages.length||policy.single===false))throw Error('single-parent');
        const minimum=singleMode?1:policy?.minimum;
        const quantity=Number(this.dataset.parentQuantity);
        const bundle=JSON.parse(this.dataset.composition);
        if (!policy || !Number.isSafeInteger(quantity) || quantity<1 || bundle.v!==2 || String(bundle.s?._BS_productId)!==parent || !Array.isArray(bundle.c) || !bundle.c.length) throw Error('kit');
        const choices=new Map();let units=0,lissageUnits=0;
        for(const tuple of bundle.c) {
          const id=String(tuple?.[0]), count=tuple?.[1];
          if(!Array.isArray(tuple)||tuple.length!==3||!/^[1-9]\d*$/.test(id)||choices.has(id)||!Number.isSafeInteger(count)||count<1||!Number.isSafeInteger(tuple[2])||tuple[2]<0)throw Error('component');
          choices.set(id,count);units+=count;if(lissages.includes(id))lissageUnits+=count;
        }
        if(!Number.isSafeInteger(units)||units<minimum||(lissages.length&&lissageUnits<1)||(singleMode&&lissageUnits!==units))throw Error('minimum');
        const rows=Array.from(this.querySelectorAll('[data-component-id]')),metadata=new Map(),physical=new Map();
        for(const row of rows) {
          const id=row.dataset.componentId,price=Number(row.dataset.referencePrice),count=Number(row.dataset.physicalQuantity);
          if(!choices.has(id)||row.dataset.referencePrice===''||!Number.isSafeInteger(price)||price<0||!Number.isSafeInteger(count)||count<1)throw Error('metadata');
          if(metadata.has(id)&&metadata.get(id).price!==price)throw Error('price');
          if(!metadata.has(id))metadata.set(id,{row,price});
          const aggregate=(physical.get(id)||0)+count;
          if(!Number.isSafeInteger(aggregate))throw Error('quantity');
          physical.set(id,aggregate);
        }
        const matches=multiplier=>[...choices].every(([id,q])=>physical.get(id)===q*multiplier);
        if(metadata.size!==choices.size||(!matches(1)&&!matches(quantity)))throw Error('quantity');
        for(const [id,count] of choices) {
          const {row}=metadata.get(id);
          row.querySelector('[data-component-quantity]').textContent=String(count);
          const remove=row.querySelector('[data-component-remove]');
          if(count>1)remove.setAttribute('aria-label',remove.getAttribute('aria-label')+' ('+count+' ×)');
          if(units-count<minimum||(lissages.length&&lissageUnits-(lissages.includes(id)?count:0)<1)){remove.setAttribute('aria-disabled','true');remove.title=this.dataset.minimum;}
        }
        rows.forEach(row=>{if(metadata.get(row.dataset.componentId).row!==row)row.hidden=true;});
        this.querySelector('[data-component-heading]').textContent=this.dataset.title.replace('[count]',String(units));
        this.dataset.ready='true';
        this.addEventListener('click',event=>{
          const link=event.target.closest('[data-component-remove]');if(!link)return;
          if(link.getAttribute('aria-disabled')==='true'){event.preventDefault();status.textContent=this.dataset.minimum;return;}
          if(this.dataset.busy==='true'){event.preventDefault();return;}
          this.dataset.busy='true';status.textContent=this.dataset.removing;
        });
      } catch (_) {
        this.querySelectorAll('[data-component-remove]').forEach(link=>{link.setAttribute('aria-disabled','true');link.removeAttribute('href');});
      }
    }
  }
  customElements.define('lbb-lissage-cart',LBBLissageCart);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-lissage-kit-help"] && !Shopify.designMode) return;
  try {
    (() => {
  if (new URLSearchParams(location.search).get('lbb_mode') !== 'single') return;
  document.querySelectorAll('[data-lbb-lissage-help][data-single-enabled="true"]').forEach(help => {
    const quantity = help.querySelector('[data-lbb-lissage-help-quantity]');
    const protocol = help.querySelector('[data-lbb-lissage-help-protocol]');
    if (quantity) quantity.textContent = help.dataset.singleQuantity;
    if (protocol) protocol.textContent = help.dataset.singleProtocol;
    const changeFormat = help.querySelector('[data-lbb-lissage-change-format]');
    if (changeFormat) { const url = new URL(changeFormat.href); url.searchParams.delete('lbb_offer'); url.hash = 'composer-mes-lissages'; changeFormat.href = url.pathname + url.search + url.hash; }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbb-lissage-kit-ui"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('lbb-lissage-kit-ui-config');
    if (!config || config.dataset.initialized === 'true') return;
    config.dataset.initialized = 'true';
    const entities = { '&amp;': '&', '&quot;': '"', '&apos;': "'", '&#39;': "'", '&#x27;': "'", '&lt;': '<', '&gt;': '>' };
    const text = Object.fromEntries(Object.entries(config.dataset).map(([key, value]) => [key, String(value).replace(/&(?:amp|quot|apos|#39|#x27|lt|gt);/gi, entity => entities[entity.toLowerCase()])]));
    const params = new URLSearchParams(location.search);
    const minoaMode = config.dataset.kitBrand === 'Minoa';
    const singleMode = !minoaMode && params.get('lbb_mode') === 'single';
    const configuredMinimum = Number(config.dataset.minimumUnits || 2);
    const minimumUnits = singleMode ? 1 : configuredMinimum;
    if (minoaMode) Object.assign(text, { title: text.minoaTitle, instruction: text.minoaInstruction, descLissage: text.minoaDescLissage, stepMask: text.minoaStepMask, descMask: text.minoaDescMask, stepShampoo: text.minoaStepMaintenance, descShampoo: text.minoaDescMaintenance });
    if (singleMode) Object.assign(text, { title: text.singleTitle, instruction: text.singleInstruction, minimum: text.singleMinimum, requiredLissage: text.singleMinimum, descLissage: text.singleInstruction, stepLissage: text.singleStep, addKit: text.singleSubmit, review: text.singleSubmit });
    const labels = [text.stepLissage, text.stepPreparer, text.stepMask, text.stepShampoo, text.stepConditioner, text.stepLeavein];
    const descriptions = [text.descLissage, text.descPreparer, text.descMask, text.descShampoo, text.descConditioner, text.descLeavein];
    const allowedVariants = new Set((config.dataset.allowedVariants || '').split(',').filter(id => /^[1-9]\d*$/.test(id)));
    const lissageVariants = new Set((config.dataset.lissageVariants || '').split(',').filter(id => /^[1-9]\d*$/.test(id)));
    const stepCount = Number(config.dataset.stepCount || 6);
    const catalogueValid = stepCount === (minoaMode ? 4 : 6) && Number.isSafeInteger(minimumUnits) && minimumUnits >= 1 && allowedVariants.size > 0 && lissageVariants.size > 0 && [...lissageVariants].every(id => allowedVariants.has(id));
    const variantProducts = new Map(), productVariants = new Map(), variantFamilies = new Map(), productFamilies = new Map(), variantFormats = new Map();
    config.querySelectorAll('[data-lbb-lissage-variant-map]').forEach(node => {
      const item = node.dataset;
      if (!/^[1-9]\d*$/.test(item.productId || '') || !allowedVariants.has(item.variantId)) return;
      variantProducts.set(item.variantId, item.productId);
      if (item.format && item.format !== 'Default Title') variantFormats.set(item.variantId, item.format);
      const variants = productVariants.get(item.productId) || new Set();
      variants.add(item.variantId); productVariants.set(item.productId, variants);
      if (minoaMode && ['indian', 'gloss'].includes(item.family)) { variantFamilies.set(item.variantId, item.family); productFamilies.set(item.productId, item.family); }
    });
    const familiesOf = selected => new Set([...selected.keys()].map(id => variantFamilies.get(id)).filter(Boolean));
    const familyOfCard = card => productFamilies.get(card?.dataset.productId) || variantFamilies.get(card?.dataset.productId) || '';
    const startVariant = params.get('lbb_start_variant') || '';
    let startState = startVariant ? 'waiting' : 'none', startTimer = 0, startFeedback = '';
    let startAttempted = false;
    const cardImages = new Map();
    config.querySelectorAll('[data-lbb-lissage-variant-image]').forEach(node => {
      const item = node.dataset;
      if (!/^[1-9]\d*$/.test(item.productId || '') || !allowedVariants.has(item.variantId) || !item.src) return;
      const images = cardImages.get(item.productId) || [];
      images.push({ variantId: item.variantId, src: item.src, alt: item.alt || '' });
      cardImages.set(item.productId, images);
    });
    const mobile = matchMedia('(max-width: 767px)');
    let currentRoot, currentCart, allowedNative, navigation, edit;
    let navigationTimer = 0, editTimer = 0, initializationTimer = 0;
    let scheduled = false, expanded = false, initializing = true, feedback = '';
    let submitting = false, loadingSeen = false, requestSeen = false, succeeded = false, confirmedError = false, token = 0;
    let chatStyle = null;
    const rootOf = () => document.getElementById('bundlesuiteContainer');
    const numberOf = node => /^\d+$/.test(node?.dataset.sectionIndex || '') ? Number(node.dataset.sectionIndex) : -1;
    const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
    const setAttr = (node, name, value) => { if (node.getAttribute(name) !== value) node.setAttribute(name, value); };
    const enabled = button => button && !button.disabled && !button.classList.contains('disabled') && !button.classList.contains('loading') && button.getAttribute('aria-disabled') !== 'true';
    const checkoutEnabled = button => button?.matches('.side-cart-checkout-cta button') && enabled(button);
    const snapshot = root => {
      const sections = Array.from(root.querySelectorAll('.individual-products-section[data-section-index]')).sort((a, b) => numberOf(a) - numberOf(b));
      const tabs = Array.from(root.querySelectorAll('.condition-link[data-section-index]')).sort((a, b) => numberOf(a) - numberOf(b));
      const rows = Array.from(root.querySelectorAll('.sc-product-item[data-variant-id]'));
      const selected = new Map();
      let valid = catalogueValid && sections.length === stepCount && tabs.length === stepCount, units = 0, lissageUnits = 0, stale = false;
      sections.forEach((section, index) => { if (numberOf(section) !== index || numberOf(tabs[index]) !== index) valid = false; });
      rows.forEach(row => {
        const id = row.dataset.variantId;
        const raw = row.querySelector('.scpt-price-quantity')?.textContent.trim() || '';
        const quantity = Number(raw);
        if (!/^[1-9]\d*$/.test(id || '') || selected.has(id) || !/^[1-9]\d*$/.test(raw) || !Number.isSafeInteger(quantity)) valid = false;
        if (!allowedVariants.has(id)) { valid = false; stale = true; }
        selected.set(id, quantity);
        if (!row.querySelector('.scpt-gift-label')) { units += quantity; if (lissageVariants.has(id)) lissageUnits += quantity; }
      });
      if (!Number.isSafeInteger(units)) valid = false;
      if (singleMode && units !== lissageUnits) { valid = false; stale = true; }
      const active = tabs.filter(tab => tab.classList.contains('active'));
      const index = active.length === 1 ? numberOf(active[0]) : -1;
      if (index < 0 || index >= stepCount || (singleMode && index !== 0)) valid = false;
      const signature = [...selected].sort(([a], [b]) => a.localeCompare(b)).map(([id, quantity]) => id + ':' + quantity).join('|');
      const families = familiesOf(selected), familyConflict = minoaMode && families.size > 1;
      return { root, sections, tabs, rows, selected, units, lissageUnits, index, signature, valid, stale, families, familyConflict };
    };
    const make = (tag, className, content) => { const node = document.createElement(tag); node.className = className; if (content) node.textContent = content; if (tag === 'button') node.type = 'button'; return node; };
    const stop = event => { event.preventDefault(); event.stopImmediatePropagation(); };
    const nativeClick = button => {
      const checkout = button.matches('.side-cart-checkout-cta button');
      if (checkout) { config.dataset.nativeCheckoutClick = 'dispatching'; config.dataset.nativeCheckoutCapture = 'not-observed'; }
      allowedNative = button;
      try { button.click(); }
      finally { allowedNative = null; if (checkout) config.dataset.nativeCheckoutClick = 'returned'; }
    };
    const updateMinoaFormats = state => {
      if (!minoaMode) return;
      state.sections[3]?.querySelectorAll('.product-card[data-product-id]').forEach(card => {
        const variants = productVariants.get(card.dataset.productId);
        const variantId = card.querySelector('.quantity-controls[data-variant-id]')?.dataset.variantId || (variantFormats.has(card.dataset.productId) ? card.dataset.productId : variants?.size === 1 ? [...variants][0] : '');
        const format = variantFormats.get(variantId);
        const title = card.querySelector('.product-title');
        if (!format || !title) return;
        let label = title.querySelector('.lbb-lissage-kit-format');
        if (!label) { label = make('p', 'lbb-lissage-kit-format'); title.append(label); }
        setText(label, format);
      });
    };
    const updateDuoOffer = state => {
      if (!minoaMode) return;
      const template = document.getElementById('lbb-lissage-kit-duo-template');
      if (!template?.content) return;
      let note = state.root.querySelector('.lbb-lissage-kit-duo-note');
      if (!note) {
        note = template.content.firstElementChild.cloneNode(true);
        state.root.querySelector('.lbb-lissage-kit-instruction')?.after(note);
      }
      note.hidden = state.families.size > 0 && !state.families.has('indian');
    };
    const updateFamilyCards = state => {
      if (!minoaMode) return;
      const family = state.families.size === 1 ? [...state.families][0] : '';
      state.root.querySelectorAll('.product-card[data-product-id]').forEach(card => {
        const cardFamily = familyOfCard(card);
        const variants = productVariants.get(card.dataset.productId);
        const selected = state.selected.has(card.dataset.productId) || [...(variants || [])].some(id => state.selected.has(id));
        setAttr(card, 'data-lbb-family-hidden', family && cardFamily && cardFamily !== family && !selected ? 'true' : 'false');
      });
      state.sections.forEach((section, index) => {
        if (index > 2) return;
        let help = section.querySelector('.lbb-lissage-family-help');
        if (!help) { help = make('p', 'lbb-lissage-family-help'); section.querySelector('.condition-description')?.after(help); }
        setText(help, family ? text.familyChange : '');
      });
    };
    const considerStartVariant = state => {
      if (startState !== 'waiting' || !state.valid) return;
      if (!lissageVariants.has(startVariant) || !allowedVariants.has(startVariant)) { startState = 'unavailable'; startFeedback = text.startUnavailable; return; }
      if (window.LBBLissageKitEdit?.active || params.has('lbb_edit')) { startState = 'preserved'; return; }
      if (state.selected.size) { startState = 'preserved'; if (!state.selected.has(startVariant)) startFeedback = text.startKept; return; }
      if (startTimer || startAttempted || state.index !== 0) return;
      startTimer = setTimeout(() => {
        startTimer = 0;
        const root = rootOf(); if (!root || startState !== 'waiting') return;
        const fresh = snapshot(root);
        if (!fresh.valid || fresh.selected.size || window.LBBLissageKitEdit?.active || submitting || edit || navigation) { considerStartVariant(fresh); return; }
        const productId = variantProducts.get(startVariant);
        const variants = productVariants.get(productId);
        const cards = [...fresh.sections[0].querySelectorAll('.product-card[data-product-id]')].filter(card => card.dataset.productId === productId || card.dataset.productId === startVariant);
        if (!productId || variants?.size !== 1 || !variants.has(startVariant) || cards.length !== 1) { startState = 'unavailable'; startFeedback = text.startUnavailable; schedule(); return; }
        const card = cards[0], button = card.querySelector('.add-button');
        if (!enabled(button) || button.dataset.stockStatus !== 'in-stock' || button.dataset.preOrder === 'true') { startState = 'unavailable'; startFeedback = text.startUnavailable; schedule(); return; }
        startAttempted = true; startState = 'attempted';
        nativeClick(button); schedule();
        setTimeout(() => {
          const current = rootOf();
          if (!current) return;
          if (snapshot(current).selected.has(startVariant)) startState = 'selected';
          else { startState = 'unavailable'; startFeedback = text.startUnavailable; }
          schedule();
        }, 1200);
      }, 350);
    };
    const clearNavigation = () => { navigation = null; clearTimeout(navigationTimer); navigationTimer = 0; };
    const clearEdit = () => { edit = null; clearTimeout(editTimer); editTimer = 0; };
    const focusStep = section => { if (!section?.getClientRects().length) return; const heading = section.querySelector('.section-title') || section; setAttr(heading, 'tabindex', '-1'); heading.focus({ preventScroll: true }); section.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); };
    const goTo = (state, index) => {
      if (!state.valid || !Number.isInteger(index) || index < 0 || index >= stepCount || (singleMode && index !== 0)) return false;
      if (index > state.index && state.lissageUnits < 1) { feedback = text.requiredLissage; schedule(); return false; }
      if (index === state.index) { focusStep(state.sections[index]); return true; }
      const direction = index > state.index ? 1 : -1;
      const button = Array.from(state.root.querySelectorAll(direction > 0 ? '.bundle-step-button.next-step' : '.bundle-step-button.prev-step')).find(enabled);
      if (!button) return false;
      clearNavigation();
      const operation = { root: state.root, target: index, from: state.index, expected: state.index + direction };
      navigation = operation; expanded = false; feedback = '';
      nativeClick(button);
      navigationTimer = setTimeout(() => { if (navigation === operation) { clearNavigation(); feedback = text.configurationError; schedule(); } }, 2000);
      schedule(); return true;
    };
    const nextStep = state => { if (state.lissageUnits < 1) { feedback = text.requiredLissage; schedule(); return; } if (singleMode || state.index === stepCount - 1) submitKit(state); else if (!goTo(state, state.index + 1)) { feedback = text.configurationError; schedule(); } };
    const actionsFor = (host, className, actions, index) => {
      let group = host.querySelector('.' + className);
      if (group) return group;
      group = make('div', className + ' lbb-lissage-kit-actions');
      for (const action of actions) { const button = make('button', 'lbb-lissage-kit-' + action); button.dataset.lissageKitAction = action; if (index !== undefined) button.dataset.lissageKitSectionIndex = String(index); setAttr(button, 'aria-describedby', 'lbb-lissage-kit-status'); group.append(button); }
      return group;
    };
    const controlsFor = cart => {
      let controls = cart.querySelector('.lbb-lissage-kit-controls'); if (controls) return controls;
      controls = make('div', 'lbb-lissage-kit-controls'); controls.append(make('span', 'lbb-lissage-kit-progress'), make('span', 'lbb-lissage-kit-count'));
      const status = make('p', 'lbb-lissage-kit-status'); status.id = 'lbb-lissage-kit-status'; setAttr(status, 'role', 'status'); setAttr(status, 'aria-live', 'polite'); controls.append(status);
      controls.append(actionsFor(controls, 'lbb-lissage-kit-summary-actions', ['previous', 'skip', 'submit'])); cart.append(controls); return controls;
    };
    const setNativeLabel = (node, value) => {
      if (!node || !value) return;
      const leaves = Array.from(node.childNodes || []).filter(child => child.nodeType === 3 && child.textContent.trim());
      if (leaves.length === 1) setText(leaves[0], value);
      else if (!node.children?.length) setText(node, value);
    };
    // Commercial copy for the two Minoa parents whose native 8% rule was verified.
    // Keep this copy synchronized if that offer changes. Monetary amounts remain native.
    const minoaDiscountRuleMatches = () => {
      return minoaMode && ['15705118310665', '15705139052809'].includes(config.dataset.kitProductId)
        && Number(config.dataset.minoaDiscountPercent) === 8 && minimumUnits === 2 && stepCount === 4;
    };
    const updateMinoaDiscountOffer = (root, state) => {
      if (!minoaMode) return;
      const matched = minoaDiscountRuleMatches();
      root.classList.toggle('lbb-minoa-discount-ready', matched);
      let offer = root.querySelector('.lbb-minoa-kit-offer');
      const tabs = root.querySelector('.condition-links-container');
      if (!offer && matched && tabs) {
        offer = make('aside', 'lbb-minoa-kit-offer');
        offer.append(make('strong', '', text.minoaDiscountOffer), make('p', '', text.minoaDiscountDetails));
        tabs.before(offer);
      }
      if (offer) offer.hidden = !matched;
      const toggle = root.querySelector('.lbb-lissage-kit-toggle-label');
      if (!toggle) return;
      let saving = toggle.querySelector('.lbb-minoa-kit-saving');
      if (!saving) { saving = make('span', 'lbb-minoa-kit-saving'); toggle.append(saving); }
      const nativeAmount = root.querySelector('.side-cart-checkout-item.discount p:last-child')?.textContent.trim();
      const eligible = matched && state.valid && !state.familyConflict && state.units >= minimumUnits && state.lissageUnits >= 1;
      saving.hidden = !eligible || !nativeAmount;
      if (!saving.hidden) setText(saving, text.minoaDiscountSaving.replace('[amount]', nativeAmount));
    };
    const localizeNativeControls = root => {
      const discountLabel = minoaDiscountRuleMatches() ? text.minoaDiscountLabel : text.discountLabel;
      for (const [selector, label] of [['.subtotal-text', text.subtotalLabel], ['.discount-text', discountLabel], ['.additional-text', text.discountLabel], ['.total-text', text.totalLabel]]) {
        root.querySelectorAll('.side-cart-checkout-wrapper ' + selector).forEach(node => setNativeLabel(node, label));
      }
      root.querySelectorAll('.product-card .add-button').forEach(button => {
        if (button.classList.contains('loading') || button.dataset.preOrder === 'true') return;
        if (button.dataset.stockStatus === 'in-stock') setNativeLabel(button, text.addProduct);
        else if (button.dataset.stockStatus === 'out-of-stock') setNativeLabel(button, text.unavailable);
      });
      root.querySelectorAll('.cart-empty').forEach(node => setNativeLabel(node, text.emptyKit));
      document.querySelectorAll('.product-variant-selector-cta button').forEach(button => {
        if (button.classList.contains('loading') || button.dataset.preOrder === 'true') return;
        const current = button.textContent.trim();
        const label = button.dataset.stockStatus === 'out-of-stock' || /^(?:out of stock|sold out|unavailable|indisponible|rupture de stock|épuisé)$/i.test(current)
          ? text.unavailable : current === text.selected || /^(?:already added|déjà ajouté|choix effectué|selection made|selected)$/i.test(current)
            ? text.selected : button.dataset.stockStatus === 'in-stock' || /^(?:add to (?:cart|bundle)|ajouter au (?:panier|kit)|choisir)$/i.test(current) ? text.addProduct : null;
        if (label) { setNativeLabel(button, label); setAttr(button, 'aria-label', label); }
      });
      document.querySelectorAll('.product-variant-selector').forEach(modal => {
        modal.querySelectorAll('.close-variant-selector button').forEach(button => { setAttr(button, 'aria-label', text.close); setAttr(button, 'title', text.close); });
        const title = modal.querySelector('.product-variant-selector-header h3')?.textContent.replace(/\s+/g, ' ').trim();
        for (const [selector, label] of [['.quantity-input', text.quantity], ['.quantity-btn.plus', text.increase], ['.quantity-btn.minus', text.decrease], ['.remove-item-btn', text.remove]]) {
          modal.querySelectorAll(selector).forEach(node => setAttr(node, 'aria-label', label + (title ? ' : ' + title : '')));
        }
      });
      [root, ...document.querySelectorAll('.product-variant-selector')].forEach(scope => {
        scope.querySelectorAll('[aria-label]').forEach(node => {
          const label = node.getAttribute('aria-label');
          if (/^(?:regular price|prix normal|prix habituel)$/i.test(label)) setAttr(node, 'aria-label', text.regularPrice);
          else if (/^(?:sale price|prix réduit|prix promotionnel)$/i.test(label)) setAttr(node, 'aria-label', text.salePrice);
        });
      });
      root.querySelectorAll('.cart-totoal-added-products p').forEach(node => {
        const counter = node.querySelector('.added-products-count');
        const raw = counter ? counter.textContent.trim() : node.textContent.trim().match(/^(\d+)\s+/)?.[1];
        if (!/^\d+$/.test(raw || '') || !Number.isSafeInteger(Number(raw))) return;
        const label = Number(raw) === 1 ? text.nativeItemOne : text.nativeItemMany;
        setNativeLabel(node, counter ? ' ' + label : raw + ' ' + label);
      });
      document.querySelectorAll('.bundle-toast.success .bundle-toast-message').forEach(node => {
        const message = node.textContent.trim();
        if (message === text.addedToCart) return;
        if (/^Added .+ to bundle[.!]?$/i.test(message) || /^.+ ajout[ée]e? (?:au|dans le) (?:kit|panier|bundle)[.!]?$/i.test(message)) setNativeLabel(node, text.productAdded);
        else if (/^Removed .+ from bundle[.!]?$/i.test(message) || /^.+ retir[ée]e? (?:du|de votre) (?:kit|panier|bundle)[.!]?$/i.test(message)) setNativeLabel(node, text.productRemoved);
      });
    };
    const updateCardImages = root => {
      root.querySelectorAll('.individual-products-section .product-card[data-product-id]').forEach(card => {
        const images = cardImages.get(card.dataset.productId);
        if (!images || images.length !== 1) return;
        const image = images[0];
        const selected = card.querySelector('.quantity-controls')?.dataset.variantId;
        if (selected && selected !== image.variantId) return;
        const element = card.querySelector('.product-card-image img');
        if (!element) return;
        setAttr(element, 'src', image.src);
        if (element.hasAttribute('srcset')) element.removeAttribute('srcset');
        setAttr(element, 'alt', image.alt);
      });
    };
    const labelProductControls = (root, rows) => {
      const clean = value => (value || '').replace(/\s+/g, ' ').trim();
      const rowsByVariant = new Map(rows.map(row => [row.dataset.variantId, row]));
      const cardsByVariant = new Map();
      root.querySelectorAll('.product-card .quantity-controls[data-variant-id]').forEach(control => {
        if (control.dataset.variantId) cardsByVariant.set(control.dataset.variantId, control.closest('.product-card'));
      });
      for (const [selector, action] of [['.quantity-input', text.quantity], ['.quantity-btn.plus', text.increase], ['.quantity-btn.minus', text.decrease], ['.remove-item-btn', text.remove]]) {
        root.querySelectorAll(selector).forEach(node => {
          const row = node.closest('.sc-product-item') || rowsByVariant.get(node.closest('.quantity-controls')?.dataset.variantId);
          const card = node.closest('.product-card') || cardsByVariant.get(row?.dataset.variantId);
          const title = clean(row?.querySelector('.scpt-title h4')?.textContent || card?.querySelector('.product-title h4')?.textContent);
          const format = clean(row?.querySelector('.scpt-variant p')?.textContent || card?.querySelector('.lbb-lissage-kit-format')?.textContent);
          const includesFormat = title.replace(/\s/g, '').toLowerCase().includes(format.replace(/\s/g, '').toLowerCase());
          const context = title + (title && format && !includesFormat ? ' · ' + format : '');
          setAttr(node, 'aria-label', action + (context ? ' : ' + context : ''));
        });
      }
    };
    const updateSpace = () => {
      const active = mobile.matches && !!currentRoot && !!currentCart;
      for (const [name, value] of [['lbb-lissage-kit-mobile', active], ['lbb-lissage-kit-expanded', active && expanded]]) {
        if (document.documentElement.classList.contains(name) !== value) document.documentElement.classList.toggle(name, value);
      }
      const height = active ? Math.ceil(currentCart.getBoundingClientRect().height) : 0;
      if (active && !expanded && height > 0) currentRoot.style.setProperty('--lbb-lissage-kit-space', height + 'px');
      const shadow = document.querySelector('shopify-chat')?.shadowRoot;
      if (chatStyle && (!active || expanded || chatStyle.parentNode !== shadow)) { chatStyle.remove(); chatStyle = null; }
      if (!active || expanded || !shadow) return;
      if (!chatStyle) { chatStyle = document.createElement('style'); shadow.append(chatStyle); }
      setText(chatStyle, '@media(max-width:767px){.activator-nudge{bottom:' + (Math.max(height, 140) + 12) + 'px!important;width:44px!important;max-width:44px!important;min-width:44px!important;height:44px!important;padding:0!important}.activator-nudge>button.activator[part="activator"]{width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;padding:0!important;gap:0!important}.activator__label{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important}}');
    };
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(updateSpace) : null;
    const resetSubmission = message => { submitting = false; loadingSeen = false; requestSeen = false; succeeded = false; confirmedError = false; token++; if (message) feedback = message; schedule(); };
    const render = () => {
      const root = rootOf(), cart = root?.querySelector('.side-cart-container');
      if (!root || !cart) { currentRoot = null; currentCart = null; updateSpace(); return; }
      if (currentRoot !== root) { currentRoot = root; clearNavigation(); clearEdit(); feedback = ''; expanded = false; resetSubmission(); }
      if (currentCart !== cart) { currentCart = cart; resize?.disconnect(); resize?.observe(cart); }
      root.classList.add('lbb-lissage-kit');
      root.classList.toggle('lbb-lissage-single', singleMode);
      const tabsHost = root.querySelector('.condition-links-container');
      const title = root.querySelector('.template-top-data-header-title h2');
      if (title) setText(title, text.title);
      else if (tabsHost && !root.querySelector('.lbb-lissage-kit-title')) tabsHost.before(make('h2', 'lbb-lissage-kit-title', text.title));
      if (tabsHost && !root.querySelector('.lbb-lissage-kit-instruction')) tabsHost.before(make('p', 'lbb-lissage-kit-instruction', text.instruction));
      const state = snapshot(root);
      root.classList.toggle('lbb-lissage-single-discount', singleMode && state.valid && state.units >= 2);
      if (state.valid) { initializing = false; clearTimeout(initializationTimer); }
      else if (initializing && !initializationTimer) initializationTimer = setTimeout(() => { initializing = false; schedule(); }, 5000);
      if (edit && edit.signature !== state.signature) { clearEdit(); feedback = ''; }
      if (state.stale) expanded = true;
      if (navigation && state.valid) {
        const operation = navigation;
        if (state.index === operation.target) { clearNavigation(); focusStep(state.sections[state.index]); }
        else if (state.index === operation.expected) { clearNavigation(); if (!goTo(state, operation.target)) feedback = text.configurationError; }
        else if (state.index !== operation.from) { clearNavigation(); feedback = text.configurationError; }
      }
      const checkout = root.querySelector('.side-cart-checkout-cta button');
      if (confirmedError && checkout && !checkout.disabled && !checkout.classList.contains('disabled')) { checkout.classList.remove('loading'); resetSubmission(text.submitError); }
      const loading = !!checkout?.classList.contains('loading');
      if (submitting && loading) loadingSeen = true;
      if (submitting && loadingSeen && !loading && !requestSeen && !succeeded) resetSubmission(text.submitError);
      const cartEdit = window.LBBLissageKitEdit;
      const editBlocked = cartEdit?.active && (!cartEdit.ready || cartEdit.blocked || cartEdit.saving);
      const saveLabel = cartEdit?.active ? cartEdit.saveLabel : text.addKit;
      const reviewLabel = cartEdit?.active ? cartEdit.saveLabel : text.review;
      const singleBlocked = singleMode && (!window.LBBLissageSingleMode?.ready || window.LBBLissageSingleMode.blocked);
      const busy = submitting || !!edit || !!navigation || !!editBlocked || singleBlocked;
      const canSubmit = state.valid && !state.familyConflict && state.units >= minimumUnits && state.lissageUnits >= 1 && !busy && checkoutEnabled(checkout);
      const progress = index => singleMode ? text.singleProgress : text.categoryProgress.replace('[current]', String(Math.max(0, index) + 1)).replace('[total]', String(stepCount));
      const controls = controlsFor(cart);
      state.sections.forEach((section, index) => {
        setText(section.querySelector('.section-title'), labels[index] + (singleMode ? '' : ' · ' + (index === 0 ? text.required : text.optional)));
        let description = section.querySelector('.condition-description');
        if (!description) { description = make('p', 'condition-description'); section.querySelector('.section-title')?.after(description); }
        setText(description, descriptions[index]);
        const grid = section.querySelector('.individual-products-container'); if (!grid) return;
        for (const position of ['top', 'bottom']) {
          const group = actionsFor(section, 'lbb-lissage-kit-grid-nav-' + position, ['previous', 'next'], index);
          if (!group.parentElement) { if (position === 'top') grid.before(group); else grid.after(group); }
          setAttr(group, 'role', 'group'); setAttr(group, 'aria-label', progress(index));
          const previous = group.querySelector('.lbb-lissage-kit-previous'), next = group.querySelector('.lbb-lissage-kit-next');
          previous.hidden = singleMode;
          setText(previous, text.previous); previous.disabled = !state.valid || busy || index !== state.index || index === 0;
          setText(next, (singleMode || index === stepCount - 1) ? submitting ? text.adding : reviewLabel : text.next); next.disabled = !state.valid || busy || index !== state.index || state.lissageUnits < 1 || ((singleMode || index === stepCount - 1) && !canSubmit);
        }
      });
      state.tabs.forEach((tab, index) => { setText(tab, labels[index]); setAttr(tab, 'title', labels[index]); setAttr(tab, 'aria-disabled', busy || (index > state.index && state.lissageUnits < 1) ? 'true' : 'false'); });
      setText(controls.querySelector('.lbb-lissage-kit-progress'), progress(state.index));
      setText(controls.querySelector('.lbb-lissage-kit-count'), text.selectionCount.replace('[count]', String(state.units)));
      setText(controls.querySelector('.lbb-lissage-kit-status'), singleMode && window.LBBLissageSingleMode?.blocked ? text.configurationError : state.stale ? text.staleSelection : state.familyConflict ? text.familyConflict : feedback || startFeedback || (!state.valid ? initializing ? text.loading : text.configurationError : state.lissageUnits < 1 ? text.requiredLissage : state.units < minimumUnits ? text.minimum : ''));
      const previous = controls.querySelector('.lbb-lissage-kit-previous'), skip = controls.querySelector('.lbb-lissage-kit-skip'), submit = controls.querySelector('.lbb-lissage-kit-submit');
      previous.hidden = singleMode; skip.hidden = singleMode;
      setText(previous, text.previous); previous.disabled = !state.valid || busy || state.index === 0;
      const activeSelected = state.sections[state.index]?.querySelectorAll('.quantity-controls[data-variant-id]');
      const hasSelected = Array.from(activeSelected || []).some(node => state.selected.has(node.dataset.variantId));
      setText(skip, state.index === stepCount - 1 ? submitting ? text.adding : reviewLabel : state.index === 0 || hasSelected ? text.next : text.skip); skip.disabled = !state.valid || busy || state.lissageUnits < 1 || (state.index === stepCount - 1 && !canSubmit);
      setText(submit, submitting ? text.adding : saveLabel); submit.disabled = !canSubmit;
      setAttr(root, 'aria-busy', submitting || (!state.valid && initializing) ? 'true' : 'false');
      setText(root.querySelector('.cart-head h3'), text.kitTitle);
      localizeNativeControls(root);
      updateCardImages(root);
      updateMinoaFormats(state);
      updateFamilyCards(state);
      updateDuoOffer(state);
      considerStartVariant(state);
      labelProductControls(root, state.rows);
      let toggle = cart.querySelector('.lbb-lissage-kit-toggle');
      if (!toggle) { toggle = make('button', 'lbb-lissage-kit-toggle'); toggle.dataset.lissageKitAction = 'toggle'; const label = make('span', 'lbb-lissage-kit-toggle-label'); label.append(make('strong', '', text.kitTitle), make('span', 'lbb-lissage-kit-toggle-action')); toggle.append(label, make('span', 'lbb-lissage-kit-toggle-total')); cart.prepend(toggle); }
      setAttr(toggle, 'aria-expanded', mobile.matches && expanded ? 'true' : 'false');
      const panels = [];
      for (const [selector, suffix] of [['.side-cart-product-container', 'products'], ['.side-cart-checkout-wrapper', 'totals']]) { const panel = cart.querySelector(selector); if (panel) { if (!panel.id) panel.id = 'lbb-lissage-kit-panel-' + suffix; panels.push(panel.id); } }
      setAttr(toggle, 'aria-controls', panels.join(' '));
      setText(toggle.querySelector('.lbb-lissage-kit-toggle-action'), expanded ? text.collapse : text.details);
      setText(toggle.querySelector('.lbb-lissage-kit-toggle-total'), state.units ? root.querySelector('.side-cart-checkout-wrapper .total-value')?.textContent.trim() || '' : '');
      updateMinoaDiscountOffer(root, state);
      cart.classList.toggle('lbb-lissage-kit-open', mobile.matches && expanded); updateSpace();
    };
    const observer = new MutationObserver(() => schedule());
    const observe = () => observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'disabled', 'aria-disabled', 'data-variant-id', 'data-section-index', 'src', 'srcset'] });
    function schedule() { if (scheduled) return; scheduled = true; requestAnimationFrame(() => { scheduled = false; observer.disconnect(); try { render(); } finally { observe(); } }); }
    const submitKit = state => {
      if (submitting || edit || navigation) return;
      if (singleMode && (!window.LBBLissageSingleMode?.ready || window.LBBLissageSingleMode.blocked)) { feedback = text.configurationError; schedule(); return; }
      const cartEdit = window.LBBLissageKitEdit;
      if (cartEdit?.active && (!cartEdit.ready || cartEdit.blocked || cartEdit.saving)) return;
      if (!state.valid) { feedback = text.configurationError; schedule(); return; }
      if (state.familyConflict) { feedback = text.familyConflict; expanded = true; schedule(); return; }
      if (state.lissageUnits < 1) { feedback = text.requiredLissage; schedule(); return; }
      if (state.units < minimumUnits) { feedback = text.minimum; schedule(); return; }
      const buttons = Array.from(state.root.querySelectorAll('.side-cart-checkout-cta button')).filter(checkoutEnabled);
      if (buttons.length !== 1) { feedback = text.configurationError; schedule(); return; }
      const operation = ++token; submitting = true; requestSeen = false; succeeded = false; confirmedError = false; loadingSeen = false; feedback = '';
      config.dataset.checkoutAttempts = String((Number(config.dataset.checkoutAttempts) || 0) + 1);
      config.dataset.cartRequestState = 'not-observed'; config.dataset.cartHttpStatus = '';
      nativeClick(buttons[0]); loadingSeen = buttons[0].classList.contains('loading'); schedule();
      setTimeout(() => { if (operation === token && !loadingSeen && !requestSeen && !succeeded) resetSubmission(text.submitError); }, 1500);
    };
    document.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const root = rootOf(), popup = target?.closest('.product-variant-selector-cta button');
      if (!root || !target || (!root.contains(target) && !popup)) return;
      if (allowedNative && (target === allowedNative || allowedNative.contains(target))) {
        if (allowedNative.matches('.side-cart-checkout-cta button')) config.dataset.nativeCheckoutCapture = 'allowed';
        return;
      }
      const state = snapshot(root), custom = target.closest('[data-lissage-kit-action]');
      const cartEdit = window.LBBLissageKitEdit;
      if (cartEdit?.active && (!cartEdit.ready || cartEdit.blocked || cartEdit.saving) && custom?.dataset.lissageKitAction !== 'toggle') { stop(event); return; }
      if (custom) {
        stop(event); const action = custom.dataset.lissageKitAction;
        if (action === 'toggle') { expanded = !expanded; schedule(); return; }
        if (custom.disabled || submitting || navigation || edit) return;
        if (custom.dataset.lissageKitSectionIndex !== undefined && Number(custom.dataset.lissageKitSectionIndex) !== state.index) return;
        if (action === 'submit') submitKit(state);
        else if (action === 'previous') { feedback = ''; goTo(state, state.index - 1); }
        else if (action === 'next' || action === 'skip') nextStep(state);
        return;
      }
      const final = target.closest('.side-cart-checkout-cta button'), next = target.closest('.bundle-step-button.next-step'), previous = target.closest('.bundle-step-button.prev-step'), tab = target.closest('.condition-link[data-section-index]');
      if (final || next || previous || tab) { stop(event); if (submitting || navigation || edit) return; if (final) submitKit(state); else if (next) nextStep(state); else if (!goTo(state, previous ? state.index - 1 : numberOf(tab))) { feedback = state.valid && state.lissageUnits < 1 && numberOf(tab) > state.index ? text.requiredLissage : text.configurationError; schedule(); } return; }
      const nativeEdit = popup || target.closest('.add-button, .quantity-btn, .remove-item-btn');
      if (!nativeEdit) return;
      const remove = nativeEdit.matches('.remove-item-btn');
      const decrease = nativeEdit.matches('.quantity-btn.minus');
      if (minoaMode && !remove && !decrease) {
        const card = popup ? root.querySelector('.product-card[data-active="true"]') : nativeEdit.closest('.product-card');
        const rowId = nativeEdit.closest('.sc-product-item')?.dataset.variantId;
        const candidateFamily = familyOfCard(card) || variantFamilies.get(rowId) || '';
        if (state.familyConflict || (candidateFamily && [...state.families].some(family => family !== candidateFamily))) { stop(event); feedback = state.familyConflict ? text.familyConflict : text.familyBlocked; expanded = true; schedule(); return; }
      }
      if (startState === 'waiting') { clearTimeout(startTimer); startTimer = 0; startState = 'preserved'; }
      startFeedback = '';
      if (submitting || navigation || (edit && !popup) || (!state.valid && !remove) || !enabled(nativeEdit)) { stop(event); return; }
      clearEdit(); feedback = ''; edit = { signature: state.signature };
      editTimer = setTimeout(() => { clearEdit(); schedule(); }, 8000); schedule();
    }, true);
    document.addEventListener('lbb:lissage-single-mode', () => schedule());
    document.addEventListener('lbb:lissage-kit-cart-request', event => { const state = event.detail?.state; if (state === 'pending') { submitting = true; requestSeen = true; clearEdit(); } else if (state === 'success') { submitting = true; requestSeen = true; succeeded = true; } else if (state === 'error') { confirmedError = true; feedback = text.submitError; } schedule(); });
    window.addEventListener('pageshow', event => { if (event.persisted) { clearNavigation(); clearEdit(); resetSubmission(); } });
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && expanded) { expanded = false; schedule(); currentCart?.querySelector('.lbb-lissage-kit-toggle')?.focus(); } });
    mobile.addEventListener('change', () => { expanded = false; schedule(); });
    observe(); schedule();
  })();
  } catch(e) { console.error(e); }
})();

})();
